import * as React from "react";
import "./dataMapTable.scss";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import {
  Grid,
  Box,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";
import MapInput from "../../MapData/MapInput";
import Buttons from "../../Controls/Buttons/Button";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearResetProDataFromPre,
  resetProDataFromPre,
  mapData,
  setBboxFromDrawFromPre,
  heighlightBBoxInPre,
} from "../../../redux/pre_processor/actions";
import {
  aeReInitiateProVlm,
  setBboxFromDraw,
  // getProDataForReset,
  setSelectedFileDataForProUpdateMapping,
} from "../../../redux/processor/actions";

import CellMenu from "./CellMenu";
import RangeSelector from "./RangeSelector";
import DataTypeSelector from "./DataTypeSelector";
import NewParameter from "./NewParameter";
import {
  dataEntry,
  pageRedirection,
  setOCRValue,
  rejectData,
} from "../../../redux/processor/actions";
import Validation from "./Validation";
import {
  rejectValidatorData,
  validateData,
  isSignatureUploaded,
} from "../../../redux/validator/actions";
import ValidationButton from "./ValidationButton";
import moment from "moment";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import AlertTitle from "@mui/material/AlertTitle";
// import { Prompt } from "react-router-dom";
import RowRejectAndReviewNew from "./RowRejectAndReviewNew";
import Label from "../../Label/Label";
import EditableCell from "./EditableCell";
import { action } from "../../../constants/action";
import ModalSign from "../../Modal/Signature/ModalSign";
import Authentication from "../../Modal/PopupModal/PopupModal";
import AddMoreColumnTH from "./AddMoreColumnTH";
import ParameterName from "./ParameterName";
import { logObject } from "../../../config/logs";
import CustomizedSnackbars from "../../Snackbars/CustomizedSnackbars";
import CellValueHistory from "./CellValueHistory";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Tooltip, IconButton } from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? "#1A2027" : "var(--bg-white)",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const MapDataTable = React.forwardRef((props, ref) => {
  const {
    selectedFile,
    parametersData: parametersDataFromState,
    selectedArea,
    role,
    reProcess,
    reValidate,
    isDataRejectedByValidator,
    isDataRejectedByProcessor,
    isDataRejectedByInvestigatorValidator,
    entireBatchRejectedByInvestigatorValidator,
    isDataRejectedByInvestigatorMappingValidator,
    entireBatchRejectedByInvestigatorMappingValidator,
    // isFullView,
    resetPdfHeighlights,
    entireBatchRejectedByPro,
    entireBatchRejectedByVali,
    reProcessEntireBatch,
    showContextMenu,
    resestSelectedArea,
    onCellChangeInPre,
    showParameterTable,
    summary,
    hideScreen,
  } = props;

  const dispatch = useDispatch();
  const cellMenuRef = React.useRef(null);

  const [parametersData, setParametersData] = useState(parametersDataFromState);
  const [rejectedCount, setRejectedCount] = useState(0);
  const [validatedAndRejectedCounts, setValidatedAndRejectedCounts] = useState({
    validated: 0,
    rejected: 0,
  });
  const [cellToUpdate, setCellToUpdate] = useState({
    parameterIndex: null,
    mappingIndex: null,
  });
  // const [rowRejectionData, setRowRejectionData] = useState([]);
  const [isAlert, setAlert] = useState({
    open: false,
    message: "",
    title: "",
  });
  // below bindOcrValuesAndCoords is used for pro role used for cnc
  const bindOcrValuesAndCoords = useSelector(
    (state) => state?.pro?.bindOcrValuesAndCoords,
  );
  const bboxFromDraw = useSelector((state) => state?.pro?.bboxFromDraw);
  const bboxFromDrawFromPre = useSelector(
    (state) => state?.prePro?.bboxFromDrawFromPre,
  );

  const selectedFilesDataForProUpdate = useSelector(
    (state) => state?.pro?.selectedFilesDataForProUpdate,
  );
  const coordinatesData = useSelector((state) => {
    if (role === "preProcessor") {
      return state?.prePro?.coorData?.coordinatesDetails;
    } else if (role === "processor") {
      return state?.pro?.coorData?.coordinatesDetails;
    } else if (role === "validator") {
      return state?.vali?.coorData?.coordinatesDetails;
    }
  });
  const resetProDataFromPreResponse = useSelector(
    (state) => state?.prePro?.resetProDataFromPreResponse,
  );
  const reProcessVlmCountsFromAPi = useSelector(
    (state) => state?.pro?.coorData?.mapping_details?.reProcessVlmCounts || 0,
  );

  const anyOperationPerformedOnEntirePage = React.useRef(false);
  const [isUpdateParameters, setIsUpdateParameters] = useState(false);
  const [openAuth, setOpenAuth] = useState(false);
  const [openSignPad, setOpenSignPad] = useState(false);
  const [, setToggleStateOnly] = useState(false);

  const [logs, setLogs] = useState([]);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [success, setSuccess] = useState(false);
  // const roleMapping = {
  //   preProcessor: "prePro",
  //   processor: "pro",
  //   validator: "vali",
  // };

  // const useRejectionCounts = (role, rejectionType) => {
  //   const roleKey = roleMapping[role];

  //   return useSelector(
  //     (state) =>
  //       state?.[roleKey]?.coorData?.mapping_details?.[
  //         `${rejectionType}RejectionCounts`
  //       ] || 0
  //   );
  // };

  // the below rejection count logic is removed from other client branches as its not required, but only kept and used this is in qc branch to enable/disable reprocess menu in cell
  // const [processorsRejectionCounts, setProcessorsRejectionCounts] = useState(
  // useRejectionCounts(role, "processors")
  // );

  // const [validatorsRejectionCounts, setValidatorsRejectionCounts] = useState(
  //   useRejectionCounts(role, "validators")
  // );

  const [columnWidths, setColumnWidths] = useState({
    sr: 20,
    parameter: 175,
    dataType: 85,
    range: 100,
    input: 100,
    rejection: 100,
  });

  const [reProcessVlmCounts, setReProcessVlmCounts] = useState(
    reProcessVlmCountsFromAPi,
  );

  const [showReviewRemarkColumnHeader, setShowReviewRemarkColumnHeader] =
    useState(false);

  useEffect(() => {
    if (
      parametersData?.length > 0 &&
      (role === "processor" || role === "validator")
    ) {
      const shouldShowHeader = parametersData.some(
        (row) =>
          row?.processorRowRejection?.isResolved === true ||
          row?.validatorRowRejection?.isResolved === true,
      );
      setShowReviewRemarkColumnHeader(shouldShowHeader);
    }
  }, [parametersData]);

  useEffect(() => {
    window.addEventListener("beforeunload", beforeunloadFunc);

    return () => {
      // Anything in here is fired on component unmount.
      window.removeEventListener("beforeunload", beforeunloadFunc);
    };
  }, []);

  useEffect(() => {
    if (parametersData && parametersData[0] && parametersData[0]?.mappings) {
      parametersData[0]?.mappings?.map((item, index) => {
        columnWidths[`header${index}`] = 100;
      });
      setColumnWidths({ ...columnWidths });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parametersDataFromState]);

  useEffect(() => {
    let validatedCount = 0;
    let rejectedCount = 0;

    if (Array.isArray(parametersData)) {
      parametersData.forEach((entry) => {
        if (entry?.rowValidation?.isValidated) {
          validatedCount++;
        } else if (entry?.validatorRowRejection?.isRejected) {
          rejectedCount++;
        }
      });
    }
    setValidatedAndRejectedCounts({
      ...validatedAndRejectedCounts,
      validated: validatedCount,
      rejected: rejectedCount,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parametersData]);

  const beforeunloadFunc = (e) => {
    if (anyOperationPerformedOnEntirePage.current) {
      e.preventDefault();
      e.returnValue = true;
    }
  };

  const handleCloseAuth = () => {
    setOpenAuth(false);
  };

  const handleCloseSignPad = () => {
    setOpenSignPad(false);
    dispatch(isSignatureUploaded());
  };

  const handleUserPermission = () => {
    dispatch(
      validateData({
        parametersData: parametersData,
        batch_id: localStorage.batchId,
        projectId: localStorage.projectId,
        next: true,
        extractionType: "template_driven",
        partially_validated: false,
        logs: logs,
        // autosave
      }),
    );
  };

  // Call the mapData function repeatedly after a delay
  // useEffect(() => {
  // const intervalId = setInterval(() => {
  // callMapdata("save", null, null, null, true); // Pass autosave=true here
  // }, 120000); // 2 min

  // Cleanup function to clear the interval if the component unmounts or if the repetition is no longer needed
  // return () => clearInterval(intervalId);
  // }, []); // Empty dependency array ensures the effect runs only once after the component mounts

  const autoSaveTimeout = React.useRef(null);

  useEffect(() => {
    const resetTimer = () => {
      clearTimeout(autoSaveTimeout.current);

      autoSaveTimeout.current = setTimeout(() => {
        callMapdata("save", null, null, null, true);
      }, 300000);
    };

    const events = ["mousedown", "keydown", "input", "touchstart"];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {
      clearTimeout(autoSaveTimeout.current);

      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, []);

  const callMapdata = (
    action,
    remark,
    batchRejection,
    signUploaded,
    autosave = false,
  ) => {
    anyOperationPerformedOnEntirePage.current = false;
    setToggleStateOnly((prev) => !prev);
    if (action !== "save") {
      if (rejectedCount >= 1) {
        action = "reject";
      }
    }
    const next = action === "saveAndNext" ? true : false;
    const extractionType = "template_driven";
    if (role === "preProcessor") {
      if (action === "saveAndNext") {
        // if (processorsRejectionCounts) {
        const rejectionFound = parametersData?.some((item) => {
          if (
            item?.mappings?.some(
              (mapping) =>
                mapping?.processorCellRejection?.isRejected === true ||
                mapping?.investigatorMappingValidatiorCellRejection
                  ?.isRejected === true,
            )
          ) {
            return true; // Stop iteration
          }
          if (
            item?.processorRowRejection?.isRejected === true ||
            item?.investigatorMappingValidatiorRowRejection?.isRejected === true
          ) {
            return true; // Stop iteration
          }
          return false; // Continue checking other items
        });
        if (rejectionFound) {
          setAlert({
            ...isAlert,
            open: true,
            message:
              "Some rejection are not resolved. please resolve them before continue.",
            title: "Resolve Rejections",
          });
        } else {
          // // let notificationPrinted = false; // Flag to indicate if a notification is printed

          // // Outer loop
          // parameterLoop: for (
          //   let parameterIndex = 0;
          //   parameterIndex < parametersData.length;
          //   parameterIndex++
          // ) {
          //   const parameterDataItem = parametersData[parameterIndex];

          //   // Inner loop
          //   for (
          //     let mappingIndex = 0;
          //     mappingIndex < parameterDataItem.mappings.length;
          //     mappingIndex++
          //   ) {
          //     const mappingsItem = parameterDataItem.mappings[mappingIndex];
          //     // const keyMappingPageNo = mappingsItem.keyData?.pageNo;
          //     const valueMappingPageNo = mappingsItem.pageNo;

          //     // const keyMappingCoordinatesLength =
          //     //   (parametersData[parameterIndex]?.mappings[mappingIndex]
          //     //     ?.keyCoordinates &&
          //     //     parametersData[parameterIndex]?.mappings[mappingIndex]
          //     //       ?.keyCoordinates?.length) ||
          //     //   0;
          //     const valueMappingCoordinatesLength =
          //       (parametersData[parameterIndex]?.mappings[mappingIndex]
          //         ?.coordinates &&
          //         parametersData[parameterIndex]?.mappings[mappingIndex]
          //           ?.coordinates?.length) ||
          //       0;
          //     //when mapping with data entry is done by processor then avoid validation
          //     if (
          //       parametersData[parameterIndex]?.mappings[mappingIndex]
          //         ?.forNoPreProMappingDataEntryByPro !== true
          //     ) {
          //       if (
          //         // keyMappingPageNo !== "" &&
          //         // keyMappingPageNo !== undefined &&
          //         // keyMappingPageNo !== null &&
          //         // keyMappingPageNo >= 0 &&
          //         valueMappingPageNo === "" ||
          //         valueMappingPageNo === undefined ||
          //         valueMappingPageNo === null ||
          //         (valueMappingPageNo !== "" &&
          //           valueMappingPageNo !== undefined &&
          //           valueMappingPageNo !== null &&
          //           valueMappingPageNo >= 0)
          //         // &&
          //         // (keyMappingPageNo === "" ||
          //         //   keyMappingPageNo === undefined ||
          //         //   keyMappingPageNo === null)
          //       ) {
          //         notificationPrinted = true;
          //         console.log("Stopping all Child iterations...");
          //         // Break out of both loops
          //         break parameterLoop;
          //       } else if (
          //         // (keyMappingPageNo !== "" &&
          //         //   keyMappingPageNo !== undefined &&
          //         //   keyMappingPageNo !== null &&
          //         //   keyMappingPageNo >= 0 &&
          //         //   keyMappingCoordinatesLength <= 0) ||
          //         valueMappingPageNo !== "" &&
          //         valueMappingPageNo !== undefined &&
          //         valueMappingPageNo !== null &&
          //         valueMappingPageNo >= 0 &&
          //         valueMappingCoordinatesLength <= 0
          //       ) {
          //         notificationPrinted = true;
          //         console.log("Stopping all Child iterations...");
          //         // Break out of both loops
          //         break parameterLoop;
          //       }
          //     }
          //     console.log("aaa");
          //   }

          //   // If notification is printed, stop all next iterations
          // }
          // if (notificationPrinted) {
          //   console.log("Stopping all  parent iterations...");
          //   // Break out of the outer loop
          //   setAlert({
          //     ...isAlert,
          //     open: true,
          //     message:
          //       "Some fields are not mapped. Please map them before continuing.",
          //     title: "Mapping incomplete.",
          //   });
          // } else {
          dispatch(
            mapData({
              parametersData: parametersData,
              projectId: localStorage.projectId,
              next: next,
              extractionType: extractionType,
              isUpdateParameters: isUpdateParameters,
              isDataRejectedByProcessor: false,
              ...(isDataRejectedByProcessor && {
                reProcess: true,
              }),
              ...(isDataRejectedByValidator && {
                isDataRejectedByValidator: true,
              }),
              ...(isDataRejectedByInvestigatorValidator && {
                isDataRejectedByInvestigatorValidator: true,
              }),
              ...(entireBatchRejectedByInvestigatorValidator && {
                entireBatchRejectedByInvestigatorValidator: true,
              }),
              entireBatchRejectedByPro: false,
              ...(entireBatchRejectedByPro && {
                reProcessEntireBatch: true,
              }),
              logs: logs,
              // processorsRejectionCounts: processorsRejectionCounts,
              // validatorsRejectionCounts: validatorsRejectionCounts,
              autosave,
            }),
          );
        }
      } else if (action === "save") {
        dispatch(
          mapData({
            parametersData: parametersData,
            projectId: localStorage.projectId,
            next: next,
            extractionType: extractionType,
            isUpdateParameters: isUpdateParameters,
            ...(isDataRejectedByProcessor && {
              isDataRejectedByProcessor: true,
            }),
            ...(isDataRejectedByValidator && {
              isDataRejectedByValidator: true,
            }),
            ...(isDataRejectedByInvestigatorValidator && {
              isDataRejectedByInvestigatorValidator: true,
            }),
            ...(entireBatchRejectedByInvestigatorValidator && {
              entireBatchRejectedByInvestigatorValidator: true,
            }),
            ...(entireBatchRejectedByPro && {
              entireBatchRejectedByPro: true,
            }),
            logs: logs,
            // processorsRejectionCounts: processorsRejectionCounts,
            // validatorsRejectionCounts: validatorsRejectionCounts,
            autosave,
            onSaveSuccess: () => {
              setLogs([]); // Clear logs after debugging
            },
          }),
        );
        // setLogs([]); // clearing logs because if user click saveAndNext then also previous log will pass to api so to avoid duplication need to clear logs
      }
    }

    if (role === "processor") {
      if (action === "reject") {
        const updatedParametersData = parametersData?.map((item) => {
          if (item?.enableCellsForNewColumn === true) {
            return {
              ...item,
              enableCellsForNewColumn: false,
            };
          }
          return item;
        });

        dispatch(
          rejectData({
            parametersData: updatedParametersData,
            batch_id: localStorage.batchId,
            next: next,
            extractionType: extractionType,
            ...(isDataRejectedByValidator && {
              isDataRejectedByValidator: true,
            }),
            ...(isDataRejectedByInvestigatorValidator && {
              isDataRejectedByInvestigatorValidator: true,
            }),
            ...(entireBatchRejectedByInvestigatorValidator && {
              entireBatchRejectedByInvestigatorValidator: true,
            }),
            rejection_remark: remark,
            isDataRejectedByProcessor: true,
            projectId: localStorage.projectId,
            entireBatchRejectedByPro: batchRejection === true ? true : false,
            ...(entireBatchRejectedByVali && {
              entireBatchRejectedByVali: true,
            }),
            logs: logs,
            // processorsRejectionCounts: processorsRejectionCounts,
            // validatorsRejectionCounts: validatorsRejectionCounts,
            autosave,
          }),
        );
      } else if (action === "save") {
        dispatch(
          dataEntry({
            parametersData: parametersData,
            batch_id: localStorage.batchId,
            next: next,
            extractionType: extractionType,
            ...(isDataRejectedByValidator && {
              isDataRejectedByValidator: true,
            }),
            ...(isDataRejectedByInvestigatorValidator && {
              isDataRejectedByInvestigatorValidator: true,
            }),
            ...(entireBatchRejectedByInvestigatorValidator && {
              entireBatchRejectedByInvestigatorValidator: true,
            }),
            partial_data_entry: true,
            ...(entireBatchRejectedByVali && {
              entireBatchRejectedByVali: true,
            }),
            //  newly added
            ...(isDataRejectedByProcessor && {
              isDataRejectedByProcessor: true,
            }),
            ...(isDataRejectedByProcessor && {
              reProcess: true,
            }),
            ...(reProcessEntireBatch && {
              reProcessEntireBatch: true,
            }),
            logs: logs,
            // processorsRejectionCounts: processorsRejectionCounts,
            // validatorsRejectionCounts: validatorsRejectionCounts,
            autosave,
            reProcessVlmCounts: reProcessVlmCounts,
            ...(autosave === false && {
              onSaveSuccess: () => {
                setLogs([]); // Clear logs after debugging
              },
            }),
          }),
        );
        // setLogs([]); // clearing logs because if user click saveAndNext then also previous log will pass to api so to avoid duplication need to clear logs
      } else if (action === "saveAndNext") {
        // if (validatorsRejectionCounts) {
        const rejectionFound = parametersData?.some((item) => {
          if (
            item?.mappings?.some(
              (mapping) => mapping?.validatorCellRejection?.isRejected === true,
            )
          ) {
            return true; // Stop iteration
          }
          if (item?.validatorRowRejection?.isRejected === true) {
            return true; // Stop iteration
          }
          return false; // Continue checking other items
        });
        if (rejectionFound) {
          setAlert({
            ...isAlert,
            open: true,
            message:
              "Some rejection are not resolved. please resolve them before continue.",
            title: "Resolve Rejections",
          });
        } else {
          const updatedParametersData = parametersData?.map((item) => {
            if (item?.enableCellsForNewColumn === true) {
              return {
                ...item,
                enableCellsForNewColumn: false,
              };
            }
            return item;
          });

          // Check if any parameter contains `reInitiateProVlm = true`
          const isReInitiateProVlmForBatchRequired = parametersData.some(
            (parameterData) =>
              parameterData.mappings.some(
                (mapping) => mapping.reInitiateProVlm === true,
              ),
          );
          if (isReInitiateProVlmForBatchRequired) {
            dispatch(
              aeReInitiateProVlm({
                parametersData: updatedParametersData,
                batch_id: localStorage.batchId,
                next: next,
                extractionType: extractionType,
                ...(isDataRejectedByValidator && {
                  reValidate: true,
                }),
                ...(isDataRejectedByValidator && {
                  isDataRejectedByValidator: true,
                }),
                ...(isDataRejectedByInvestigatorValidator && {
                  reValidateInvestigatorValidator: true,
                }),
                ...(isDataRejectedByInvestigatorValidator && {
                  isDataRejectedByInvestigatorValidator: true,
                }),
                ...(entireBatchRejectedByInvestigatorValidator && {
                  entireBatchRejectedByInvestigatorValidator: true,
                }),
                partial_data_entry: false,
                entireBatchRejectedByVali: false,
                ...(entireBatchRejectedByVali && {
                  reValidateEntireBatch: true,
                }),
                logs: logs,
                // processorsRejectionCounts: processorsRejectionCounts,
                // validatorsRejectionCounts: validatorsRejectionCounts,
                autosave,
              }),
            );
          } else {
            dispatch(
              dataEntry({
                parametersData: updatedParametersData,
                batch_id: localStorage.batchId,
                next: next,
                extractionType: extractionType,
                ...(isDataRejectedByValidator && {
                  reValidate: true,
                }),
                ...(isDataRejectedByValidator && {
                  isDataRejectedByValidator: true,
                }),
                ...(isDataRejectedByInvestigatorValidator && {
                  reValidateInvestigatorValidator: true,
                }),
                ...(isDataRejectedByInvestigatorValidator && {
                  isDataRejectedByInvestigatorValidator: true,
                }),
                ...(entireBatchRejectedByInvestigatorValidator && {
                  entireBatchRejectedByInvestigatorValidator: true,
                }),
                partial_data_entry: false,
                entireBatchRejectedByVali: false,
                ...(entireBatchRejectedByVali && {
                  reValidateEntireBatch: true,
                }),
                logs: logs,
                // processorsRejectionCounts: processorsRejectionCounts,
                // validatorsRejectionCounts: validatorsRejectionCounts,
                autosave,
              }),
            );
          }
        }
      }
    }

    if (role === "validator") {
      if (action === "reject") {
        dispatch(
          rejectValidatorData({
            parametersData: parametersData,
            batch_id: localStorage.batchId,
            next: next,
            extractionType: extractionType,
            rejection_remark: remark,
            isDataRejectedByValidator: true,
            projectId: localStorage.projectId,
            entireBatchRejectedByVali: batchRejection === true ? true : false,
            logs: logs,
            // validatorsRejectionCounts: validatorsRejectionCounts,
            autosave,
            ...(isDataRejectedByInvestigatorValidator && {
              isDataRejectedByInvestigatorValidator: true,
            }),
            ...(entireBatchRejectedByInvestigatorValidator && {
              entireBatchRejectedByInvestigatorValidator: true,
            }),
          }),
        );
      } else if (action === "saveAndNext") {
        const rejectionFound = parametersData?.some((item) => {
          if (
            item?.mappings?.some(
              (mapping) =>
                mapping?.investigatorValidatiorCellRejection?.isRejected ===
                true,
            )
          ) {
            return true; // Stop iteration
          }
          if (item?.investigatorValidatiorRowRejection?.isRejected === true) {
            return true; // Stop iteration
          }
          return false; // Continue checking other items
        });
        if (rejectionFound) {
          setAlert({
            ...isAlert,
            open: true,
            message:
              "Some rejection are not resolved. please resolve them before continue.",
            title: "Resolve Rejections",
          });
        } else {
          let allValidatedData;
          if (parametersData) {
            allValidatedData = parametersData.every(
              (item) => item?.rowValidation?.isValidated,
            );
          } else {
            allValidatedData = false;
          }

          // To add is_out_of_range flag used Validation() function which is declared for range heighlight
          if (allValidatedData) {
            parametersData.forEach((parameter, parameterIndex) => {
              let isOutOfRange = false;

              parameter?.mappings?.map((mapping, mappingIndex) => {
                let outRange = false;

                outRange = Validation(
                  parameter?.dataType,
                  parameter?.range,
                  mapping?.value,
                )?.error
                  ? true
                  : false;

                if (outRange === true) {
                  isOutOfRange = true;
                }
                parametersData[parameterIndex].mappings[mappingIndex][
                  "out_of_range"
                ] = outRange;
              });

              parametersData[parameterIndex]["is_out_of_range"] = isOutOfRange;
            });
            if (signUploaded === false) {
              setOpenSignPad(true);
            } else if (signUploaded === true) {
              setOpenAuth(true);
            }
          } else {
            setAlert({
              ...isAlert,
              open: true,
              message:
                "Some fields are not validated. Please validate them before continuing.",
              title: "Validation Error",
            });
          }
        }
      } else if (action === "save") {
        dispatch(
          validateData({
            parametersData: parametersData,
            batch_id: localStorage.batchId,
            projectId: localStorage.projectId,
            next: next,
            extractionType: extractionType,
            partially_validated: true,
            logs: logs,
            // validatorsRejectionCounts: validatorsRejectionCounts,
            autosave,
            ...(isDataRejectedByInvestigatorValidator && {
              isDataRejectedByInvestigatorValidator: true,
            }),
            ...(entireBatchRejectedByInvestigatorValidator && {
              entireBatchRejectedByInvestigatorValidator: true,
            }),
            onSaveSuccess: () => {
              setLogs([]); // Clear logs after debugging
            },
          }),
        );
        // setLogs([]);
      }
    }
  };

  React.useImperativeHandle(ref, () => ({
    mapData: (action, remark, batchRejection, signUploaded, autoSave) => {
      callMapdata(action, remark, batchRejection, signUploaded, autoSave);
    },
  }));

  useEffect(() => {
    // it will never call as selection of bbox is disabled for qc 2.o
    if (selectedArea?.tableSelection !== true) {
      // This logic is used for pre pro role to add coordinates in cell wise when mapping data
      const coordinatesToAdd = selectedArea?.coords;
      const parameterIndex = cellToUpdate?.parameterIndex;
      const mappingIndex = cellToUpdate?.mappingIndex;

      // setting key coordinates for crop region selection
      // in this we dont have coordinates values to show
      // if (
      //   selectedArea?.selectionType === "table" &&
      //   selectedArea?.coords &&
      //   cellToUpdate?.mappingFor === "parameterKey"
      // ) {
      //   parametersData[parameterIndex].mappings[mappingIndex].keyCoordinates =
      //     parametersData[parameterIndex].mappings[mappingIndex].keyCoordinates
      //       ? [
      //           ...parametersData[parameterIndex].mappings[mappingIndex]
      //             .keyCoordinates,
      //           coordinatesToAdd,
      //         ]
      //       : [coordinatesToAdd];

      //   setParametersData([...parametersData]);
      //   if (!anyOperationPerformedOnEntirePage.current) {
      //     anyOperationPerformedOnEntirePage.current = true;
      //   }
      // } else

      if (
        selectedArea?.selectionType === "table" &&
        selectedArea?.coords &&
        cellToUpdate?.mappingFor === "parameterValue"
      ) {
        // to add coordinates
        parametersData[parameterIndex].mappings[mappingIndex].coordinates =
          parametersData[parameterIndex].mappings[mappingIndex].coordinates
            ? [
                ...parametersData[parameterIndex].mappings[mappingIndex]
                  .coordinates,
                coordinatesToAdd,
              ]
            : [coordinatesToAdd];

        setParametersData([...parametersData]);
        if (!anyOperationPerformedOnEntirePage.current) {
          anyOperationPerformedOnEntirePage.current = true;
        }
      }
      // normal cnc
      else if (
        selectedArea?.coords &&
        parameterIndex !== null &&
        parameterIndex >= 0 &&
        mappingIndex !== null &&
        mappingIndex >= 0 &&
        parametersData
      ) {
        // if (cellToUpdate?.mappingFor === "parameterKey") {
        //   // to add coordinates
        //   parametersData[parameterIndex].mappings[mappingIndex].keyCoordinates =
        //     parametersData[parameterIndex].mappings[mappingIndex].keyCoordinates
        //       ? [
        //           ...parametersData[parameterIndex].mappings[mappingIndex]
        //             .keyCoordinates,
        //           coordinatesToAdd,
        //         ]
        //       : [coordinatesToAdd];

        //   // to add coordinates value
        //   if (
        //     parametersData[parameterIndex].mappings[mappingIndex] &&
        //     parametersData[parameterIndex].mappings[mappingIndex]?.keyData &&
        //     parametersData[parameterIndex].mappings[mappingIndex]?.keyData
        //       ?.tagName &&
        //     parametersData[parameterIndex].mappings[mappingIndex]?.keyData
        //       ?.tagName !== "" &&
        //     parametersData[parameterIndex].mappings[mappingIndex]?.keyData
        //       ?.pageNo >= 0
        //   ) {
        //     // from be getting defficult to change payload so creating seperate array for values to show in cell menu
        //     parametersData[parameterIndex].mappings[
        //       mappingIndex
        //     ].keyCoordinatesValues = parametersData[parameterIndex].mappings[
        //       mappingIndex
        //     ].keyCoordinatesValues
        //       ? [
        //           ...parametersData[parameterIndex].mappings[mappingIndex]
        //             .keyCoordinatesValues,
        //           selectedArea?.name,
        //         ]
        //       : [selectedArea?.name];
        //   }

        //   setParametersData([...parametersData]);
        //   if (!anyOperationPerformedOnEntirePage.current) {
        //     anyOperationPerformedOnEntirePage.current = true;
        //   }
        // } else {
        // to add coordinates
        parametersData[parameterIndex].mappings[mappingIndex].coordinates =
          parametersData[parameterIndex].mappings[mappingIndex].coordinates
            ? [
                ...parametersData[parameterIndex].mappings[mappingIndex]
                  .coordinates,
                coordinatesToAdd,
              ]
            : [coordinatesToAdd];

        // to add coordinates value
        if (
          parametersData[parameterIndex].mappings[mappingIndex] &&
          parametersData[parameterIndex].mappings[mappingIndex]?.tagName &&
          parametersData[parameterIndex].mappings[mappingIndex]?.tagName !==
            "" &&
          parametersData[parameterIndex].mappings[mappingIndex]?.pageNo >= 0
        ) {
          // from be getting defficult to change payload so creating seperate array for values to show in cell menu
          parametersData[parameterIndex].mappings[
            mappingIndex
          ].coordinatesValues = parametersData[parameterIndex].mappings[
            mappingIndex
          ].coordinatesValues
            ? [
                ...parametersData[parameterIndex].mappings[mappingIndex]
                  .coordinatesValues,
                selectedArea?.name,
              ]
            : [selectedArea?.name];
        }

        setParametersData([...parametersData]);
        if (!anyOperationPerformedOnEntirePage.current) {
          anyOperationPerformedOnEntirePage.current = true;
        }
        // }
      }
    } else if (selectedArea?.tableSelection) {
      // if (cellToUpdate?.mappingFor === "parameterKey") {
      //   // for Table selection
      //   // This logic is used for pre pro role to add krycoordinates in cell wise when mapping data
      //   const coordinatesToAddTable = selectedArea?.coords;
      //   const parameterIndex = cellToUpdate?.parameterIndex;
      //   const mappingIndex = cellToUpdate?.mappingIndex;
      //   if (
      //     selectedArea?.coords &&
      //     parameterIndex !== null &&
      //     parameterIndex >= 0 &&
      //     mappingIndex !== null &&
      //     mappingIndex >= 0 &&
      //     parametersData
      //   ) {
      //     // to add coordinates
      //     parametersData[parameterIndex].mappings[mappingIndex].keyCoordinates =
      //       [coordinatesToAddTable];

      //     //to add coordinatesValues

      //     if (
      //       parametersData[parameterIndex].mappings[mappingIndex] &&
      //       parametersData[parameterIndex].mappings[mappingIndex]?.keyData &&
      //       parametersData[parameterIndex].mappings[mappingIndex]?.keyData
      //         ?.tagName &&
      //       parametersData[parameterIndex].mappings[mappingIndex]?.keyData
      //         ?.tagName !== "" &&
      //       parametersData[parameterIndex].mappings[mappingIndex]?.keyData
      //         ?.pageNo >= 0
      //     ) {
      //       // from be getting defficult to change payload so creating seperate array for values to show in cell menu
      //       parametersData[parameterIndex].mappings[
      //         mappingIndex
      //       ].keyCoordinatesValues = [selectedArea?.name];
      //     }

      //     // adding tableSelection for table selection
      //     parametersData[parameterIndex].mappings[
      //       mappingIndex
      //     ].tableSelection = true;

      //     setParametersData([...parametersData]);
      //     if (!anyOperationPerformedOnEntirePage.current) {
      //       anyOperationPerformedOnEntirePage.current = true;
      //     }
      //   }
      // } else
      //  {
      // for Table selection
      // This logic is used for pre pro role to add coordinates in cell wise when mapping data
      const coordinatesToAddTable = selectedArea?.coords;
      const parameterIndex = cellToUpdate?.parameterIndex;
      const mappingIndex = cellToUpdate?.mappingIndex;
      if (
        selectedArea?.coords &&
        parameterIndex !== null &&
        parameterIndex >= 0 &&
        mappingIndex !== null &&
        mappingIndex >= 0 &&
        parametersData
      ) {
        // to add coordinates
        parametersData[parameterIndex].mappings[mappingIndex].coordinates = [
          coordinatesToAddTable,
        ];

        //to add coordinatesValues

        if (
          parametersData[parameterIndex].mappings[mappingIndex] &&
          parametersData[parameterIndex].mappings[mappingIndex]?.tagName &&
          parametersData[parameterIndex].mappings[mappingIndex]?.tagName !==
            "" &&
          parametersData[parameterIndex].mappings[mappingIndex]?.pageNo >= 0
        ) {
          // from be getting defficult to change payload so creating seperate array for values to show in cell menu
          parametersData[parameterIndex].mappings[
            mappingIndex
          ].coordinatesValues = [selectedArea?.name];
        }

        // adding tableSelection for table selection
        parametersData[parameterIndex].mappings[mappingIndex].tableSelection =
          true;

        setParametersData([...parametersData]);
        if (!anyOperationPerformedOnEntirePage.current) {
          anyOperationPerformedOnEntirePage.current = true;
        }
      }
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedArea]);

  // the below logic is used in pro role to acheive cnc
  useEffect(() => {
    if (bindOcrValuesAndCoords?.value && bindOcrValuesAndCoords?.coords) {
      updateCell(bindOcrValuesAndCoords);
      dispatch(setOCRValue());

      if (!anyOperationPerformedOnEntirePage.current) {
        anyOperationPerformedOnEntirePage.current = true;
      }
    }
  }, [bindOcrValuesAndCoords]);

  useEffect(() => {
    const parameterIndex = cellToUpdate?.parameterIndex;
    const mappingIndex = cellToUpdate?.mappingIndex;
    if (
      bboxFromDraw?.bBoxCoords !== null &&
      bboxFromDraw?.bBoxCoords &&
      parameterIndex !== null &&
      parameterIndex >= 0 &&
      mappingIndex !== null &&
      mappingIndex >= 0 &&
      parametersData
    ) {
      parametersData[parameterIndex].mappings[mappingIndex] = {
        ...parametersData[parameterIndex].mappings[mappingIndex],
        // value: transformedValue,
        coordinates: parametersData[parameterIndex].mappings[mappingIndex]
          .coordinates
          ? [
              ...parametersData[parameterIndex].mappings[mappingIndex]
                .coordinates,
              bboxFromDraw?.bBoxCoords,
            ]
          : [bboxFromDraw?.bBoxCoords],

        // coordinates: [bboxFromDraw?.bBoxCoords],

        // coordinatesValues: [bboxFromDraw?.value],

        processor: localStorage.userRole,
        processedDate: moment(new Date()).format("DD-MMM-YYYY"),

        actual_page_number: selectedFilesDataForProUpdate?.pageNo,
        fileNo: selectedFilesDataForProUpdate?.fileNo,
        pageNo: selectedFilesDataForProUpdate?.pageNo,
        tagName: selectedFilesDataForProUpdate?.tagName,
        lockedPreTagName: selectedFilesDataForProUpdate?.tagName,
        lockedPrePageNo: selectedFilesDataForProUpdate?.pageNo,
        lockedPreFileNo: selectedFilesDataForProUpdate?.fileNo,
      };

      // in pro added page details for unmapped page by pre
      if (
        parametersData[parameterIndex].mappings[mappingIndex]?.pageNo === "" &&
        parametersData[parameterIndex].mappings[mappingIndex]?.tagName === ""
      ) {
        parametersData[parameterIndex].mappings[mappingIndex] = {
          ...parametersData[parameterIndex].mappings[mappingIndex],
          actual_page_number: selectedFilesDataForProUpdate?.pageNo,
          fileNo: selectedFilesDataForProUpdate?.fileNo,
          pageNo: selectedFilesDataForProUpdate?.pageNo,
          tagName: selectedFilesDataForProUpdate?.tagName,
          lockedPreTagName: selectedFilesDataForProUpdate?.tagName,
          lockedPrePageNo: selectedFilesDataForProUpdate?.pageNo,
          lockedPreFileNo: selectedFilesDataForProUpdate?.fileNo,
          forNoPreProMappingDataEntryByPro: true,
          coordinates: [bboxFromDraw?.bBoxCoords],
          processor: localStorage.userRole,
          processedDate: moment(new Date()).format("DD-MMM-YYYY"),
        };
      }
      setParametersData([...parametersData]);
      dispatch(setBboxFromDraw({ bBoxCoords: null }));
    }
  }, [bboxFromDraw]);

  useEffect(() => {
    const parameterIndex = cellToUpdate?.parameterIndex;
    const mappingIndex = cellToUpdate?.mappingIndex;
    if (
      bboxFromDrawFromPre?.bBoxCoords !== null &&
      bboxFromDrawFromPre?.bBoxCoords &&
      parameterIndex !== null &&
      parameterIndex >= 0 &&
      mappingIndex !== null &&
      mappingIndex >= 0 &&
      parametersData
    ) {
      parametersData[parameterIndex].mappings[mappingIndex] = {
        ...parametersData[parameterIndex].mappings[mappingIndex],
        // value: transformedValue,
        coordinates: parametersData[parameterIndex].mappings[mappingIndex]
          .coordinates
          ? [
              ...parametersData[parameterIndex].mappings[mappingIndex]
                .coordinates,
              bboxFromDrawFromPre?.bBoxCoords,
            ]
          : [bboxFromDrawFromPre?.bBoxCoords],

        // coordinates: [bboxFromDrawFromPre?.bBoxCoords],

        // coordinatesValues: [bboxFromDrawFromPre?.value],

        // preProcessor: localStorage.userRole,
        // preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),

        // // actual_page_number: selectedFilesDataForProUpdate?.pageNo,
        // fileNo: selectedFilesDataForProUpdate?.fileNo,
        // pageNo: selectedFilesDataForProUpdate?.pageNo,
        // tagName: selectedFilesDataForProUpdate?.tagName,
        // lockedPreTagName: selectedFilesDataForProUpdate?.tagName,
        // lockedPrePageNo: selectedFilesDataForProUpdate?.pageNo,
        // lockedPreFileNo: selectedFilesDataForProUpdate?.fileNo,
      };

      // in pro added page details for unmapped page by pre
      if (
        parametersData[parameterIndex].mappings[mappingIndex]?.pageNo === "" &&
        parametersData[parameterIndex].mappings[mappingIndex]?.tagName === ""
      ) {
        parametersData[parameterIndex].mappings[mappingIndex] = {
          ...parametersData[parameterIndex].mappings[mappingIndex],
          actual_page_number: selectedFilesDataForProUpdate?.pageNo,
          fileNo: selectedFilesDataForProUpdate?.fileNo,
          pageNo: selectedFilesDataForProUpdate?.pageNo,
          tagName: selectedFilesDataForProUpdate?.tagName,
          lockedPreTagName: selectedFilesDataForProUpdate?.tagName,
          lockedPrePageNo: selectedFilesDataForProUpdate?.pageNo,
          lockedPreFileNo: selectedFilesDataForProUpdate?.fileNo,
          // forNoPreProMappingDataEntryByPro: true,
          coordinates: [bboxFromDrawFromPre?.bBoxCoords],
          preProcessor: localStorage.userRole,
          preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),
        };
      }
      setParametersData([...parametersData]);
      dispatch(setBboxFromDrawFromPre({ bBoxCoords: null }));
    }
  }, [bboxFromDrawFromPre]);

  useEffect(() => {
    if (
      resetProDataFromPreResponse &&
      resetProDataFromPreResponse !== undefined
    ) {
      if (resetProDataFromPreResponse?.apiError === true) {
        setErr(true);
        setMessage(resetProDataFromPreResponse?.message);
        dispatch(clearResetProDataFromPre());
      } else if (resetProDataFromPreResponse?.apiSuccess === true) {
        setSuccess(true);
        setMessage(resetProDataFromPreResponse?.message);
        dispatch(clearResetProDataFromPre());
        // Refresh the page on success
        // setTimeout(())
        // window.location.reload();
      }
    }
  }, [resetProDataFromPreResponse, dispatch]);

  const updateCell = (bindOcrValuesAndCoords) => {
    const parameterIndex = cellToUpdate?.parameterIndex;
    const mappingIndex = cellToUpdate?.mappingIndex;
    if (
      bindOcrValuesAndCoords?.value &&
      bindOcrValuesAndCoords?.coords &&
      parameterIndex !== null &&
      parameterIndex >= 0 &&
      mappingIndex !== null &&
      mappingIndex >= 0 &&
      parametersData
    ) {
      var transformedHashToNumber = bindOcrValuesAndCoords?.value?.replace(
        "#",
        "Number",
      );

      if (
        parametersData[parameterIndex].mappings[mappingIndex] &&
        transformedHashToNumber !== ""
      ) {
        var transformedValue =
          `${parametersData[parameterIndex].mappings[mappingIndex]?.value} ${transformedHashToNumber}`.trim();
      } else {
        transformedValue = `${transformedHashToNumber}`.trim();
      }

      parametersData[parameterIndex].mappings[mappingIndex] = {
        ...parametersData[parameterIndex].mappings[mappingIndex],
        value: transformedValue,
        coordinates:
          parametersData[parameterIndex].mappings[mappingIndex]?.coordinates &&
          parametersData[parameterIndex].mappings[mappingIndex]?.coordinates
            ?.length >= 0
            ? [
                ...parametersData[parameterIndex].mappings[mappingIndex]
                  ?.coordinates,
                bindOcrValuesAndCoords?.coords,
              ]
            : [bindOcrValuesAndCoords?.coords],

        coordinatesValues:
          parametersData[parameterIndex].mappings[mappingIndex]
            ?.coordinatesValues &&
          parametersData[parameterIndex].mappings[mappingIndex]
            ?.coordinatesValues?.length >= 0
            ? [
                ...parametersData[parameterIndex].mappings[mappingIndex]
                  ?.coordinatesValues,
                bindOcrValuesAndCoords?.value,
              ]
            : [bindOcrValuesAndCoords?.value],

        processor: localStorage.userRole,
        processedDate: moment(new Date()).format("DD-MMM-YYYY"),
      };

      // in pro added page details for unmapped page by pre
      if (
        parametersData[parameterIndex].mappings[mappingIndex]?.pageNo === "" &&
        parametersData[parameterIndex].mappings[mappingIndex]?.tagName === ""
      ) {
        parametersData[parameterIndex].mappings[mappingIndex] = {
          ...parametersData[parameterIndex].mappings[mappingIndex],
          fileNo: selectedFilesDataForProUpdate?.fileNo,
          pageNo: selectedFilesDataForProUpdate?.pageNo,
          tagName: selectedFilesDataForProUpdate?.tagName,
          lockedPreTagName: selectedFilesDataForProUpdate?.tagName,
          lockedPrePageNo: selectedFilesDataForProUpdate?.pageNo,
          lockedPreFileNo: selectedFilesDataForProUpdate?.fileNo,
          forNoPreProMappingDataEntryByPro: true,
        };
      }
      setParametersData([...parametersData]);
    }
  };

  const onHandleChangeDatatype = (dataType, parameter, parameterIndex) => {
    parametersData[parameterIndex].range = { min: "", max: "" };
    parametersData[parameterIndex].dataType = dataType;
    setParametersData([...parametersData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "template",
        category: role === "preProcessor" ? "mapping" : "dataEntry",
        action: "Datatype Added",
        parameter: parameter,
        dataType: dataType,
      }),
    ]);
  };

  const handleRange = (value, parameterIndex, type) => {
    parametersData[parameterIndex].range[type] = value;
    setParametersData([...parametersData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "template",
        category: "preProcessor" ? "mapping" : "dataEntry",
        action: `${type === "min" ? "Minimum" : "Maximum"} Range Added`,
        parameter: parametersData[parameterIndex]?.parameter,
        // ...(type === "min" ? { rangeMin: value } : { rangeMax: value }),
        rangeMin:
          type === "min" ? value : parametersData[parameterIndex]?.range?.min,
        rangeMax:
          type === "max" ? value : parametersData[parameterIndex]?.range?.max,
        dataType: parametersData[parameterIndex]?.dataType,
      }),
    ]);
  };

  const onClickMapping = (e, parameterIndex, mappingIndex, string) => {
    e.preventDefault();

    const currentParameter = parametersData?.[parameterIndex];
    const currentMapping = currentParameter?.mappings?.[mappingIndex];

    if (!currentParameter || !currentMapping || !selectedFile) {
      return;
    }

    const toComparableNumber = (value) => {
      if (value === null || value === undefined || value === "") {
        return null;
      }

      const number = Number(value);
      return Number.isFinite(number) ? number : null;
    };

    const sameNumber = (a, b) =>
      toComparableNumber(a) === toComparableNumber(b);

    const sameText = (a, b) => (a ?? "") === (b ?? "");

    const sameCell =
      cellToUpdate?.parameterIndex === parameterIndex &&
      cellToUpdate?.mappingIndex === mappingIndex;

    const sameContext =
      sameText(currentMapping.tagName, selectedFile.tagName) &&
      sameNumber(currentMapping.pageNo, selectedFile.pageNo) &&
      sameNumber(currentMapping.fileNo, selectedFile.fileNo);

    const needsMappingUpdate = !sameContext;

    // Same cell, same context, and no missing mapping metadata:
    // avoid state updates and coordinate resets.
    if (sameCell && !needsMappingUpdate) {
      dispatch(
        heighlightBBoxInPre({
          fileNo: currentMapping?.fileNo,
          tagName: currentMapping?.tagName,
          pageNo: currentMapping?.pageNo,
          coordinates: currentMapping?.coordinates,
        }),
      );

      cellMenuRef.current?.openParameterQuestionModal(
        currentParameter.parameter_question ?? "",
      );
      return;
    }

    // Build a new mapping only when initialization or context
    // changes are actually required.
    let updatedMapping = currentMapping;

    if (needsMappingUpdate) {
      updatedMapping = {
        ...currentMapping,

        tagName: selectedFile.tagName,
        pageNo: selectedFile.pageNo,
        fileNo: selectedFile.fileNo,

        lockedPreTagName: selectedFile.tagName,
        lockedPrePageNo: selectedFile.pageNo,
        lockedPreFileNo: selectedFile.fileNo,

        rowColIndex: [Number(parameterIndex) + 1, Number(mappingIndex) + 1],

        preProcessor: localStorage.getItem("userName"),
        preProcessedDate:
          currentMapping.preProcessedDate || moment().format("DD-MMM-YYYY"),

        parameter_question: currentParameter.parameter_question ?? "",

        // Preserve existing coordinates if the context is unchanged.
        // Clear them only when the file/page/tag changes.
        coordinates: sameContext
          ? Array.isArray(currentMapping.coordinates)
            ? currentMapping.coordinates
            : []
          : [],

        coordinatesValues: sameContext
          ? Array.isArray(currentMapping.coordinatesValues)
            ? currentMapping.coordinatesValues
            : []
          : [],
      };

      // Update only the selected mapping. Do not mutate existing state.
      const updatedParametersData = [...parametersData];
      const updatedParameter = {
        ...currentParameter,
        mappings: [...currentParameter.mappings],
      };

      updatedParameter.mappings[mappingIndex] = updatedMapping;
      updatedParametersData[parameterIndex] = updatedParameter;

      setParametersData(updatedParametersData);

      // Retain your existing logging behavior, but log only when
      // mapping metadata actually needs initialization or updating.
      const document =
        coordinatesData?.[selectedFile.fileNo]?.pages?.[selectedFile.pageNo]
          ?.imageUrl;

      const commonLogData = {
        extractionType: "template",
        category: "mapping",
        parameter: currentParameter.parameter,
        dataType: currentParameter.dataType,
        rangeMin: currentParameter.range?.min,
        rangeMax: currentParameter.range?.max,
        coordinates: updatedMapping.coordinates,
        coordinatesValues: updatedMapping.coordinatesValues,
        tagName: updatedMapping.tagName,
        pageNo: updatedMapping.pageNo,
        fileNo: updatedMapping.fileNo,
        rowColIndex: updatedMapping.rowColIndex,
        mbrName: selectedFile.originalFileName || "",
        document,
      };

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          ...commonLogData,
          action: "Mapped",
        }),
        logObject({
          ...commonLogData,
          action: "Context Added",
          remark: updatedMapping.parameter_question,
        }),
      ]);

      if (!anyOperationPerformedOnEntirePage.current) {
        anyOperationPerformedOnEntirePage.current = true;
      }
    } else {
      dispatch(
        heighlightBBoxInPre({
          fileNo: currentMapping?.fileNo,
          tagName: currentMapping?.tagName,
          pageNo: currentMapping?.pageNo,
          coordinates: currentMapping?.coordinates,
        }),
      );
    }

    // Update the active cell when the user switches cells.
    // Also update it when the context changed on the same cell.
    setCellToUpdate({
      parameterIndex,
      mappingIndex,
      mappingFor: "parameterValue",
    });

    // Reset selection only when the active cell/context needs switching.
    resestSelectedArea();
    onCellChangeInPre();

    // Open the question modal on every click, even when the mapping
    // itself does not require an update.
    setTimeout(() => {
      cellMenuRef.current?.openParameterQuestionModal(
        currentParameter.parameter_question ?? "",
      );
    }, 500);
  };

  // const onClickParameterKeyMapping = (e, parameterIndex, mappingIndex) => {
  //   onClickMapping(e, parameterIndex, mappingIndex, "parameterKey");
  // };

  // useEffect(() => {
  //   if (isFullView) {
  //     calculateWidth(0);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const handleResize = (column, newWidth) => {
    setColumnWidths((prevWidths) => ({ ...prevWidths, [column]: newWidth }));
  };

  const handleMouseDown = (column) => (event) => {
    event.preventDefault(); // Prevent text selection during dragging

    const initialX = event.clientX;
    const initialWidth = columnWidths[column];

    const handleMouseMove = (moveEvent) => {
      const deltaX = moveEvent.clientX - initialX;
      const newWidth = Math.max(25, initialWidth + deltaX); // Set a minimum width

      handleResize(column, newWidth);
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.classList.remove("resizing");
    };

    document.body.classList.add("resizing");

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const calculateWidth = (count) => {
    let Totalcount = Number(localStorage.getItem("count")) + Number(count);
    localStorage.setItem("count", Totalcount);
  };

  const addMappingRowCallback = (count) => {
    calculateWidth(count);

    if (parametersData && parametersData[0] && parametersData[0]?.mappings) {
      for (
        let i = parseInt(parametersData[0]?.mappings.length);
        i < parseInt(parametersData[0]?.mappings.length) + parseInt(count);
        i++
      ) {
        columnWidths[`header${i}`] = 105;
      }
    }
    setColumnWidths({ ...columnWidths });

    parametersData?.map((parameter, index) => {
      for (let i = 0; i < count; i++) {
        parameter?.mappings?.push({
          tagName: "",
          pageNo: "",
          fileNo: "",
          coordinates: [],
          coordinatesValues: [],
          value: "",
        });
      }
    });
    setParametersData([...parametersData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "template",
        category: "inputs",
        action: "Columns Added",
        data: `${count} - Columns added`,
      }),
    ]);
  };

  const onClickResetButton = () => {
    const emptyData = [];
    parametersData?.map((parameterData) => {
      emptyData.push({
        parameter: parameterData?.parameter,
        dataType: "",
        range: { min: "", max: "" },
        mappings: [
          {
            tagName: "",
            pageNo: "",
            fileNo: "",
            value: "",
            coordinates: [],
            coordinatesValues: [],
          },
          {
            tagName: "",
            pageNo: "",
            fileNo: "",
            value: "",
            coordinates: [],
            coordinatesValues: [],
          },
          {
            tagName: "",
            pageNo: "",
            fileNo: "",
            value: "",
            coordinates: [],
            coordinatesValues: [],
          },
        ],
        parameter_question: parameterData?.parameter_question,
      });
    });
    resetPdfHeighlights();
    setParametersData([...emptyData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "template",
        category: "inputs",
        action: "Data Reset",
      }),
    ]);
  };

  // const onClickResetButtonProApiCall = () => {
  //   dispatch(getProDataForReset(localStorage.batchId, localStorage.projectId));

  //   setLogs((prevLogs) => [
  //     ...prevLogs,
  //     logObject({
  //       isActivity: true,
  //       extractionType: "template",
  //       category: "inputs",
  //       action: "Data Reset",
  //     }),
  //   ]);
  // };

  const rejectCell = (rejectionRemark, parameterIndex, mappingIndex) => {
    if (role === "processor") {
      parametersData[parameterIndex].mappings[mappingIndex] = {
        ...parametersData[parameterIndex].mappings[mappingIndex],
        processorCellRejection: {
          isRejected: true,
          remark: rejectionRemark,
          date: moment(new Date()).format("DD-MMM-YYYY"),
          rejectedBy: localStorage?.userName,
        },
      };
      // setProcessorsRejectionCounts((prev) => prev + 1);
    }
    if (role === "validator") {
      parametersData[parameterIndex].mappings[mappingIndex] = {
        ...parametersData[parameterIndex].mappings[mappingIndex],
        validatorCellRejection: {
          isRejected: true,
          remark: rejectionRemark,
          date: moment(new Date()).format("DD-MMM-YYYY"),
          rejectedBy: localStorage?.userName,
        },
      };
      // setValidatorsRejectionCounts((prev) => prev + 1);
    }

    setRejectedCount((prevState) => (prevState >= 0 ? prevState + 1 : 0)); // increament counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setParametersData([...parametersData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "template",
        category: role === "processor" ? "dataEntry" : "validation",
        action: "Cell Rejected",
        parameter: parametersData[parameterIndex]?.parameter,
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
        pageNo: parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
        tagName: parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
        fileNo: parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
        coordinates:
          parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
        coordinatesValues:
          parametersData[parameterIndex]?.mappings[mappingIndex]
            ?.coordinatesValues,
        dataType: parametersData[parameterIndex]?.dataType,
        value: parametersData[parameterIndex].mappings[mappingIndex]?.value,
        rowColIndex: [parseInt(parameterIndex) + 1, parseInt(mappingIndex) + 1],
        remark: rejectionRemark,
        mbrName: selectedFile?.originalFileName,
        document:
          coordinatesData[
            parseInt(
              parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo,
            )
          ]?.pages[
            parseInt(
              parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo,
            )
          ]?.imageUrl,
        ...(role === "processor"
          ? { processorRejected: true }
          : { validatorRejected: true }),
      }),
    ]);
  };

  const deleteRejection = (parameterIndex, mappingIndex) => {
    if (role === "processor") {
      delete parametersData[parameterIndex].mappings[mappingIndex][
        "processorCellRejection"
      ];
      // setProcessorsRejectionCounts((prev) => prev - 1);
    } else if (role === "validator") {
      delete parametersData[parameterIndex].mappings[mappingIndex][
        "validatorCellRejection"
      ];
      // setValidatorsRejectionCounts((prev) => prev - 1);
    }
    setRejectedCount((prevState) => (prevState > 0 ? prevState - 1 : 0)); // decrement   counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setParametersData([...parametersData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "template",
        category: role === "processor" ? "dataEntry" : "validation",
        action: "Cell Rejection Undone",
        parameter: parametersData[parameterIndex]?.parameter,
        rowColIndex: [parseInt(parameterIndex) + 1, parseInt(mappingIndex) + 1],
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
        pageNo: parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
        tagName: parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
        fileNo: parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
        // coordinates:
        //   parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
        // coordinatesValues:
        //   parametersData[parameterIndex]?.mappings[mappingIndex]
        //     ?.coordinatesValues,
        dataType: parametersData[parameterIndex]?.dataType,
        value: parametersData[parameterIndex].mappings[mappingIndex]?.value,
        // remark: rejectionRemark,
        // mbrName: selectedFile?.originalFileName,
        document:
          coordinatesData[
            parseInt(
              parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo,
            )
          ]?.pages[
            parseInt(
              parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo,
            )
          ]?.imageUrl,
        // ...(role === "processor"
        //   ? { processorRejected: true }
        //   : { validatorRejected: true }),
      }),
    ]);
  };

  const markAsResolveByProcessor = (
    parameterIndex,
    mappingIndex,
    isDataRejectedByInvestigatorMappingValidator,
  ) => {
    // changed below logic pre can mark as resolve to pros rjection and pro can mark valis rejection
    if (role === "preProcessor") {
      if (isDataRejectedByInvestigatorMappingValidator) {
        parametersData[parameterIndex].mappings[
          mappingIndex
        ].investigatorMappingValidatiorCellRejection = {
          isResolved: true,
          resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
          resolvedBy: localStorage?.userName,
          remark:
            parametersData[parameterIndex].mappings[mappingIndex]
              .investigatorMappingValidatiorCellRejection?.remark,
        };

        parametersData[parameterIndex].mappings[mappingIndex].reInitiateOcr =
          true;

        // setProcessorsRejectionCounts((prev) => prev - 1);
      } else {
        parametersData[parameterIndex].mappings[
          mappingIndex
        ].processorCellRejection = {
          isResolved: true,
          resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
          resolvedBy: localStorage?.userName,
          remark:
            parametersData[parameterIndex].mappings[mappingIndex]
              .processorCellRejection?.remark,
        };

        parametersData[parameterIndex].mappings[mappingIndex].reInitiateOcr =
          true;

        // setProcessorsRejectionCounts((prev) => prev - 1);
      }
    }

    if (role === "processor") {
      parametersData[parameterIndex].mappings[
        mappingIndex
      ].validatorCellRejection = {
        isResolved: true,
        resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
        resolvedBy: localStorage?.userName,
        remark:
          parametersData[parameterIndex].mappings[mappingIndex]
            .validatorCellRejection?.remark,
      };
      // setValidatorsRejectionCounts((prev) => prev - 1);
    }

    if (role === "validator") {
      parametersData[parameterIndex].mappings[
        mappingIndex
      ].investigatorValidatiorCellRejection = {
        isResolved: true,
        resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
        resolvedBy: localStorage?.userName,
        remark:
          parametersData[parameterIndex].mappings[mappingIndex]
            .investigatorValidatiorCellRejection?.remark,
      };
      // setValidatorsRejectionCounts((prev) => prev - 1);
    }

    setParametersData([...parametersData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "template",
        category: role === "preProcessor" ? "mapping" : "dataEntry",
        action: "Cell Rejection Resolved",
        parameter: parametersData[parameterIndex]?.parameter,
        value: parametersData[parameterIndex].mappings[mappingIndex]?.value,
        dataType: parametersData[parameterIndex]?.dataType,
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
        rowColIndex: [parseInt(parameterIndex) + 1, parseInt(mappingIndex) + 1],
        pageNo: parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
        document:
          coordinatesData[
            parseInt(
              parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo,
            )
          ]?.pages[
            parseInt(
              parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo,
            )
          ]?.imageUrl,
        mbrName: selectedFile?.originalFileName,
      }),
    ]);
  };

  const handleAddParameter = (newParameters) => {
    setIsUpdateParameters(true);
    // add new parameter in to old existed parametersData retrived from template
    let emptyMappingsForNewParameter = [];

    for (let i = 0; i < parametersData[0]?.mappings.length; i++) {
      emptyMappingsForNewParameter.push({
        tagName: "",
        pageNo: "",
        fileNo: "",
        coordinates: [],
        value: "",
        coordinatesValues: [],
      });
    }

    for (let i = 0; i < newParameters.length; i++) {
      parametersData.push({
        parameter: newParameters[i]?.parameter,
        dataType: "",
        range: { min: "", max: "" },
        mappings: [...emptyMappingsForNewParameter],
        sheetName: newParameters[i]?.sheetName,
        ...(role === "preProcessor"
          ? { isNewAddedByPre: true }
          : { isNewAddedByPro: true }),
      });
    }

    setParametersData([...parametersData]);

    // delete new parameter after added in to table
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    let newParamDataInStringFormat = ``;
    newParameters.forEach((item, index) => {
      newParamDataInStringFormat = `${newParamDataInStringFormat}${
        index + 1
      }. Parameter: ${item?.parameter}, Sheet Name: ${item?.sheetName}  `;
    });

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "template",
        category: "inputs",
        action: "Parameters Added",
        data: newParamDataInStringFormat,
      }),
    ]);
  };

  //below two functions is for row rejection in pro role
  // initially  rowRejectionData is empty but when we reject any row then only entry get added

  const handleRowRejection = (parameterIndex, remark) => {
    if (role === "processor") {
      parametersData[parameterIndex] = {
        ...parametersData[parameterIndex],
        processorRowRejection: {
          isRejected: true,
          remark: remark,
          date: moment(new Date()).format("DD-MMM-YYYY"),
          rejectedBy: localStorage?.userName,
        },
      };
      // setProcessorsRejectionCounts((prev) => prev + 1);
    } else if (role === "validator") {
      parametersData[parameterIndex] = {
        ...parametersData[parameterIndex],
        validatorRowRejection: {
          isRejected: true,
          remark: remark,
          date: moment(new Date()).format("DD-MMM-YYYY"),
          rejectedBy: localStorage?.userName,
        },
      };
      // setValidatorsRejectionCounts((prev) => prev + 1);
    }
    setRejectedCount((prevState) => (prevState >= 0 ? prevState + 1 : 0)); // increament counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setParametersData([...parametersData]);
    setValidatedAndRejectedCounts({
      ...validatedAndRejectedCounts,
      rejected:
        validatedAndRejectedCounts?.rejected >= 0
          ? validatedAndRejectedCounts?.rejected + 1
          : 0,
    });
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "template",
        category: role === "processor" ? "dataEntry" : "validation",
        action: "Row Rejected",
        parameter: parametersData[parameterIndex]?.parameter,
        rowColIndex: [parseInt(parameterIndex) + 1],
        dataType: parametersData[parameterIndex]?.dataType,
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
        remark: remark,
        ...(role === "processor"
          ? { processorRejected: true }
          : { validatorRejected: true }),
      }),
    ]);
  };

  const deleteRowRejection = (parameterIndex) => {
    if (role === "processor") {
      parametersData[parameterIndex] = {
        ...parametersData[parameterIndex],
        processorRowRejection: {},
      };
      // setProcessorsRejectionCounts((prev) => prev - 1);
    } else if (role === "validator") {
      parametersData[parameterIndex] = {
        ...parametersData[parameterIndex],
        validatorRowRejection: {},
      };
      // setValidatorsRejectionCounts((prev) => prev - 1);
    }
    setRejectedCount((prevState) => (prevState > 0 ? prevState - 1 : 0)); // decrement counter used this to toggle api(save / reject) based on rejection in row or cell happened or not
    setParametersData([...parametersData]);
    setValidatedAndRejectedCounts({
      ...validatedAndRejectedCounts,
      rejected:
        validatedAndRejectedCounts?.rejected > 0
          ? validatedAndRejectedCounts?.rejected - 1
          : 0,
    });
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "template",
        category: role === "processor" ? "dataEntry" : "validation",
        action: "Row Rejection Undone",
        parameter: parametersData[parameterIndex]?.parameter,
        rowColIndex: [parseInt(parameterIndex) + 1],
        dataType: parametersData[parameterIndex]?.dataType,
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
      }),
    ]);
  };

  const markAsResolveRejection = (
    parameterIndex,
    isDataRejectedByInvestigatorMappingValidator,
  ) => {
    // In vali ROle - mark rejection did by reviewer
    if (role === "validator") {
      parametersData[parameterIndex].investigatorValidatiorRowRejection = {
        isResolved: true,
        date: moment(new Date()).format("DD-MMM-YYYY"),
        resolvedBy: localStorage?.userName,
        remark:
          parametersData[parameterIndex].investigatorValidatiorRowRejection
            ?.remark,
      };
      setParametersData([...parametersData]);
      // setValidatorsRejectionCounts((prev) => prev - 1);
    }

    // In Pro ROle - mark rejection did by validator
    if (role === "processor") {
      parametersData[parameterIndex].validatorRowRejection = {
        isResolved: true,
        date: moment(new Date()).format("DD-MMM-YYYY"),
        resolvedBy: localStorage?.userName,
        remark: parametersData[parameterIndex].validatorRowRejection?.remark,
      };
      setParametersData([...parametersData]);
      // setValidatorsRejectionCounts((prev) => prev - 1);
    }

    if (role === "preProcessor") {
      if (isDataRejectedByInvestigatorMappingValidator) {
        parametersData[
          parameterIndex
        ].investigatorMappingValidatiorRowRejection = {
          isResolved: true,
          resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
          resolvedBy: localStorage?.userName,
          remark:
            parametersData[parameterIndex]
              .investigatorMappingValidatiorRowRejection?.remark,
        };

        parametersData[parameterIndex]?.mappings?.forEach((mapping) => {
          mapping.reInitiateOcr = true;
        });

        setParametersData([...parametersData]);
        // setProcessorsRejectionCounts((prev) => prev - 1);
      } else
        parametersData[parameterIndex].processorRowRejection = {
          isResolved: true,
          resolvedDate: moment(new Date()).format("DD-MMM-YYYY"),
          resolvedBy: localStorage?.userName,
          remark: parametersData[parameterIndex].processorRowRejection?.remark,
        };

      parametersData[parameterIndex]?.mappings?.forEach((mapping) => {
        mapping.reInitiateOcr = true;
      });

      setParametersData([...parametersData]);
      // setProcessorsRejectionCounts((prev) => prev - 1);
    }
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "template",
        category: role === "preProcessor" ? "mapping" : "dataEntry",
        action: "Row Rejection Resolved",
        parameter: parametersData[parameterIndex]?.parameter,
        rowColIndex: [parseInt(parameterIndex) + 1],
      }),
    ]);
  };

  const onClickCellToRedirect = (
    e,
    tagName,
    pageNo,
    fileNo,
    parameterIndex,
    mappingIndex,
    coordinates,
    isDisabled,
    actual_page_number,
  ) => {
    e.preventDefault();
    // if (tagName && pageNo >= 0 && fileNo >= 0) {
    if (tagName && actual_page_number >= 0 && fileNo >= 0) {
      dispatch(
        pageRedirection({
          fileNo,
          tagName,
          pageNo: actual_page_number, // in processor the page may shift so passing actual_page_number as pageNo because pageNo is used in other code generated by backend
          coordinates,
        }),
      );

      dispatch(
        setSelectedFileDataForProUpdateMapping({
          tagName: tagName,
          fileNo: fileNo,
          pageNo: actual_page_number,
        }),
      );
    }

    if (
      isDisabled &&
      (cellToUpdate?.parameterIndex !== null ||
        cellToUpdate?.mappingIndex !== null)
    ) {
      setCellToUpdate({
        parameterIndex: null,
        mappingIndex: null,
      });
    } else if (
      isDisabled &&
      (cellToUpdate?.parameterIndex === null ||
        cellToUpdate?.mappingIndex === null)
    ) {
      setCellToUpdate({
        parameterIndex: null,
        mappingIndex: null,
      });
    } else {
      setCellToUpdate({
        parameterIndex: parameterIndex,
        mappingIndex: mappingIndex,
      });
    }
  };

  const onClickValidate = (action, parameterIndex) => {
    if (action === "validate") {
      parametersData[parameterIndex]["rowValidation"] = {
        ...parametersData[parameterIndex]["rowValidation"],
        isValidated: true,
        validator: localStorage?.userName,
        date: moment(new Date()).format("DD-MMM-YYYY HH:mm:ss"),
      };
      setValidatedAndRejectedCounts({
        ...validatedAndRejectedCounts,
        validated:
          validatedAndRejectedCounts?.validated >= 0
            ? validatedAndRejectedCounts?.validated + 1
            : 0,
      });
      const logs = [];

      parametersData[parameterIndex]?.mappings?.map((item, index) => {
        logs.push(
          logObject({
            extractionType: "template",
            category: "validation",
            action: `Cell Validated`,
            parameter: parametersData[parameterIndex]?.parameter,
            dataType: parametersData[parameterIndex]?.dataType,
            rangeMin: parametersData[parameterIndex]?.range?.["min"],
            rangeMax: parametersData[parameterIndex]?.range?.["max"],
            coordinates: item?.coordinates,
            coordinatesValues: item?.coordinatesValues,
            tagName: item?.tagName,
            pageNo: item?.pageNo,
            fileNo: item?.fileNo,
            rowColIndex: [parseInt(parameterIndex) + 1, index + 1],
            value: item?.value,
            mbrName: selectedFile?.originalFileName,
            document:
              coordinatesData[
                parseInt(
                  parametersData[parameterIndex]?.mappings[index]?.fileNo,
                )
              ]?.pages[
                parseInt(
                  parametersData[parameterIndex]?.mappings[index]?.pageNo,
                )
              ]?.imageUrl,
          }),
        );
      });
      setLogs((prevLogs) => [...prevLogs, ...logs]);
    } else {
      parametersData[parameterIndex]["rowValidation"] = {};
      setValidatedAndRejectedCounts({
        ...validatedAndRejectedCounts,
        validated:
          validatedAndRejectedCounts?.validated > 0
            ? validatedAndRejectedCounts?.validated - 1
            : 0,
      });
      const logs = [];

      parametersData[parameterIndex]?.mappings?.map((item, index) => {
        logs.push(
          logObject({
            extractionType: "template",
            category: "validation",
            action: `Cell Validation Undone`,
            parameter: parametersData[parameterIndex]?.parameter,
            dataType: parametersData[parameterIndex]?.dataType,
            rangeMin: parametersData[parameterIndex]?.range?.["min"],
            rangeMax: parametersData[parameterIndex]?.range?.["max"],
            coordinates: item?.coordinates,
            coordinatesValues: item?.coordinatesValues,
            tagName: item?.tagName,
            pageNo: item?.pageNo,
            fileNo: item?.fileNo,
            rowColIndex: [parseInt(parameterIndex) + 1, index + 1],
            value: item?.value,
            mbrName: selectedFile?.originalFileName,
            document:
              coordinatesData[
                parseInt(
                  parametersData[parameterIndex]?.mappings[index]?.fileNo,
                )
              ]?.pages[
                parseInt(
                  parametersData[parameterIndex]?.mappings[index]?.pageNo,
                )
              ]?.imageUrl,
          }),
        );
      });

      setLogs((prevLogs) => [...prevLogs, ...logs]);
    }
    setParametersData([...parametersData]);
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      setAlert({ ...isAlert, open: false, message: "", title: "" });
    }

    setAlert({ ...isAlert, open: false, message: "", title: "" });
  };

  const clearMappings = (parameterIndex, mappingIndex, type) => {
    // let oldKeyData = {
    //   tagName: "",
    //   pageNo: "",
    //   fileNo: "",
    //   preProcessor: localStorage.userName,
    //   preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),
    // };

    // if (type === "toResetKeyMapping") {
    //   let cellData = {
    //     ...parametersData[parameterIndex].mappings[mappingIndex],
    //     keyCoordinates: [],
    //     keyCoordinatesValues: [],
    //     keyData: oldKeyData,
    //   };

    //   if (cellData?.tableSelection) {
    //     delete cellData.tableSelection;
    //   }

    //   parametersData[parameterIndex].mappings[mappingIndex] = cellData;
    //   setParametersData([...parametersData]);

    //   setLogs((prevLogs) => [
    //     ...prevLogs,
    //     logObject({
    //       extractionType: "template",
    //       category: role === "preProcessor" ? "mapping" : "dataEntry",
    //       action: "Key Mapping Reset",
    //       parameter: parametersData[parameterIndex]?.parameter,
    //       dataType: parametersData[parameterIndex]?.dataType,
    //       rangeMin: parametersData[parameterIndex]?.range?.["min"],
    //       rangeMax: parametersData[parameterIndex]?.range?.["max"],
    //       coordinates: cellData?.coordinates,
    //       coordinatesValues: cellData?.coordinatesValues,
    //       tagName: cellData?.tagName,
    //       pageNo: cellData?.pageNo,
    //       fileNo: cellData?.fileNo,
    //       rowColIndex: [
    //         parseInt(parameterIndex) + 1,
    //         parseInt(mappingIndex) + 1,
    //       ],
    //       value:
    //         role === "processor"
    //           ? parametersData[parameterIndex].mappings[mappingIndex]?.value
    //           : role === "preProcessor"
    //           ? `${cellData?.tagName} - ${
    //               cellData?.pageNo ? parseInt(cellData?.pageNo) + 1 : ""
    //             }`
    //           : "",
    //       mbrName: selectedFile?.originalFileName,
    //       document:
    //         role === "preProcessor"
    //           ? ""
    //           : coordinatesData[cellData?.fileNo]?.pages[cellData?.pageNo]
    //               ?.imageUrl,
    //       keyCoordinates: [],
    //       keyCoordinatesValues: [],
    //       keyData: oldKeyData,
    //     }),
    //   ]);
    // } else
    if (type === "toResetValueMapping") {
      let cellData = {
        ...parametersData[parameterIndex].mappings[mappingIndex],
        value: "",
        tagName:
          role === "preProcessor"
            ? ""
            : selectedFilesDataForProUpdate?.tagName // selectedFilesDataForProUpdate contains data only in pro role
              ? selectedFilesDataForProUpdate?.tagName
              : "",
        pageNo:
          role === "preProcessor"
            ? ""
            : selectedFilesDataForProUpdate?.pageNo >= 0
              ? selectedFilesDataForProUpdate?.pageNo
              : "",
        fileNo:
          role === "preProcessor"
            ? ""
            : selectedFilesDataForProUpdate?.fileNo >= 0
              ? selectedFilesDataForProUpdate?.fileNo
              : "",

        coordinates: [],
        coordinatesValues: [],
        ...(role === "preProcessor" && {
          preProcessor: localStorage.userName,
          preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),
        }),
        ...(role === "processor" && {
          processor: localStorage.userName,
          processedDate: moment(new Date()).format("DD-MMM-YYYY"),
        }),
      };

      if (role === "preProcessor") {
        cellData["lockedPreTagName"] = "";
        cellData["lockedPrePageNo"] = "";
        cellData["lockedPreFileNo"] = "";
      }

      if (cellData?.tableSelection) {
        delete cellData.tableSelection;
      }

      parametersData[parameterIndex].mappings[mappingIndex] = cellData;
      setParametersData([...parametersData]);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "template",
          category: role === "preProcessor" ? "mapping" : "dataEntry",
          action: "Mapping Cleared / Deleted",
          parameter: parametersData[parameterIndex]?.parameter,
          dataType: parametersData[parameterIndex]?.dataType,
          rangeMin: parametersData[parameterIndex]?.range?.["min"],
          rangeMax: parametersData[parameterIndex]?.range?.["max"],
          coordinates: cellData?.coordinates,
          coordinatesValues: cellData?.coordinatesValues,
          tagName: cellData?.tagName,
          pageNo: cellData?.pageNo,
          fileNo: cellData?.fileNo,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            parseInt(mappingIndex) + 1,
          ],
          value:
            role === "processor"
              ? parametersData[parameterIndex].mappings[mappingIndex]?.value
              : role === "preProcessor"
                ? `${cellData?.tagName} - ${
                    cellData?.pageNo ? parseInt(cellData?.pageNo) + 1 : ""
                  }`
                : "",
          mbrName: selectedFile?.originalFileName,
          document:
            role === "preProcessor"
              ? ""
              : coordinatesData[cellData?.fileNo]?.pages[cellData?.pageNo]
                  ?.imageUrl,
        }),
      ]);
    }
    //  else if (type === "toResetKeyValueMapping") {
    //   let cellData = {
    //     ...parametersData[parameterIndex].mappings[mappingIndex],
    //     value: "",
    //     tagName:
    //       role === "preProcessor"
    //         ? ""
    //         : selectedFilesDataForProUpdate?.tagName // selectedFilesDataForProUpdate contains data only in pro role
    //         ? selectedFilesDataForProUpdate?.tagName
    //         : "",
    //     pageNo:
    //       role === "preProcessor"
    //         ? ""
    //         : selectedFilesDataForProUpdate?.pageNo >= 0
    //         ? selectedFilesDataForProUpdate?.pageNo
    //         : "",
    //     fileNo:
    //       role === "preProcessor"
    //         ? ""
    //         : selectedFilesDataForProUpdate?.fileNo >= 0
    //         ? selectedFilesDataForProUpdate?.fileNo
    //         : "",
    //     coordinates: [],
    //     coordinatesValues: [],
    //     ...(role === "preProcessor" && {
    //       preProcessor: localStorage.userName,
    //       preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),
    //     }),
    //     ...(role === "processor" && {
    //       processor: localStorage.userName,
    //       processedDate: moment(new Date()).format("DD-MMM-YYYY"),
    //     }),

    //     ...(role === "preProcessor" && {
    //       keyCoordinates: [],
    //       keyCoordinatesValues: [],
    //       keyData: oldKeyData,
    //     }),

    //     ...(role === "processor" && {
    //       forNoPreProMappingDataEntryByPro: true,
    //     }),

    //     // keyCoordinates: [],
    //     // keyCoordinatesValues: [],
    //     // keyData: oldKeyData,
    //   };

    //   if (role === "preProcessor") {
    //     cellData["lockedPreTagName"] = "";
    //     cellData["lockedPrePageNo"] = "";
    //     cellData["lockedPreFileNo"] = "";
    //   }

    //   if (cellData?.tableSelection) {
    //     delete cellData.tableSelection;
    //   }

    //   parametersData[parameterIndex].mappings[mappingIndex] = cellData;
    //   setParametersData([...parametersData]);

    //   setLogs((prevLogs) => [
    //     ...prevLogs,
    //     logObject({
    //       extractionType: "template",
    //       category: role === "preProcessor" ? "mapping" : "dataEntry",
    //       action: "Key & Value Mapping Reset",
    //       parameter: parametersData[parameterIndex]?.parameter,
    //       dataType: parametersData[parameterIndex]?.dataType,
    //       rangeMin: parametersData[parameterIndex]?.range?.["min"],
    //       rangeMax: parametersData[parameterIndex]?.range?.["max"],
    //       coordinates: cellData?.coordinates,
    //       coordinatesValues: cellData?.coordinatesValues,
    //       tagName: cellData?.tagName,
    //       pageNo: cellData?.pageNo,
    //       fileNo: cellData?.fileNo,
    //       rowColIndex: [
    //         parseInt(parameterIndex) + 1,
    //         parseInt(mappingIndex) + 1,
    //       ],
    //       value:
    //         role === "processor"
    //           ? parametersData[parameterIndex].mappings[mappingIndex]?.value
    //           : role === "preProcessor"
    //           ? `${cellData?.tagName} - ${
    //               cellData?.pageNo ? parseInt(cellData?.pageNo) + 1 : ""
    //             }`
    //           : "",
    //       mbrName: selectedFile?.originalFileName,
    //       document:
    //         role === "preProcessor"
    //           ? ""
    //           : coordinatesData[cellData?.fileNo]?.pages[cellData?.pageNo]
    //               ?.imageUrl,
    //       keyCoordinates: [],
    //       keyCoordinatesValues: [],
    //       keyData: oldKeyData,
    //     }),
    //   ]);
    // }

    // let cellData = {
    //   ...parametersData[parameterIndex].mappings[mappingIndex],
    //   value: "",
    //   tagName:
    //     role === "preProcessor"
    //       ? ""
    //       : selectedFilesDataForProUpdate?.tagName // selectedFilesDataForProUpdate contains data only in pro role
    //       ? selectedFilesDataForProUpdate?.tagName
    //       : "",
    //   pageNo:
    //     role === "preProcessor"
    //       ? ""
    //       : selectedFilesDataForProUpdate?.pageNo >= 0
    //       ? selectedFilesDataForProUpdate?.pageNo
    //       : "",
    //   fileNo:
    //     role === "preProcessor"
    //       ? ""
    //       : selectedFilesDataForProUpdate?.fileNo >= 0
    //       ? selectedFilesDataForProUpdate?.fileNo
    //       : "",
    //   coordinates: [],
    //   coordinatesValues: [],
    //   ...(role === "preProcessor" && {
    //     preProcessor: localStorage.userName,
    //     preProcessedDate: moment(new Date()).format("DD-MMM-YYYY"),
    //   }),
    //   ...(role === "processor" && {
    //     processor: localStorage.userName,
    //     processedDate: moment(new Date()).format("DD-MMM-YYYY"),
    //   }),

    //   keyCoordinates: [],
    //   keyCoordinatesValues: [],
    //   keyData: oldKeyData,
    // };

    // if (cellData?.tableSelection) {
    //   delete cellData.tableSelection;
    // }

    // parametersData[parameterIndex].mappings[mappingIndex] = cellData;
    // setParametersData([...parametersData]);

    // setLogs((prevLogs) => [
    //   ...prevLogs,
    //   logObject({
    //     extractionType: "template",
    //     category: role === "preProcessor" ? "mapping" : "dataEntry",
    //     action: "Mapping Reset",
    //     parameter: parametersData[parameterIndex]?.parameter,
    //     dataType: parametersData[parameterIndex]?.dataType,
    //     rangeMin: parametersData[parameterIndex]?.range?.["min"],
    //     rangeMax: parametersData[parameterIndex]?.range?.["max"],
    //     coordinates: cellData?.coordinates,
    //     coordinatesValues: cellData?.coordinatesValues,
    //     tagName: cellData?.tagName,
    //     pageNo: cellData?.pageNo,
    //     fileNo: cellData?.fileNo,
    //     rowColIndex: [parseInt(parameterIndex) + 1, parseInt(mappingIndex) + 1],
    //     value:
    //       role === "processor"
    //         ? parametersData[parameterIndex].mappings[mappingIndex]?.value
    //         : role === "preProcessor"
    //         ? `${cellData?.tagName} - ${
    //             cellData?.pageNo ? parseInt(cellData?.pageNo) + 1 : ""
    //           }`
    //         : "",
    //     mbrName: selectedFile?.originalFileName,
    //     document:
    //       role === "preProcessor"
    //         ? ""
    //         : coordinatesData[cellData?.fileNo]?.pages[cellData?.pageNo]
    //             ?.imageUrl,
    //   }),
    // ]);
  };

  const headerAlphabetString = (num) => {
    let s = "";
    let t = null;

    while (num > 0) {
      t = (num - 1) % 26;
      s = String.fromCharCode(65 + t) + s;
      num = ((num - t) / 26) | 0;
    }
    return s || "";
  };

  const addColInBetween = (indexOfColToBeAdd, pos, column) => {
    if (parametersData && parametersData[0] && parametersData[0]?.mappings) {
      columnWidths[`header${parametersData[0]?.mappings?.length}`] = 105;
    }
    setColumnWidths({ ...columnWidths });

    // add new parameter in to old existed parametersData retrived from template
    let emptyMappingsForNewParameter = {
      tagName: "",
      pageNo: "",
      fileNo: "",
      coordinates: [],
      value: "",
      coordinatesValues: [],
      newColumn: true,
      ...(role === "processor" && {
        forNoPreProMappingDataEntryByPro: true,
      }),
      // enableCellsForNewColumn:true
    };
    const positionWhereToAdd =
      pos === "before" ? indexOfColToBeAdd : indexOfColToBeAdd + 1;

    parametersData?.map((parameter, parameterIndex) => {
      parameter.mappings.splice(
        positionWhereToAdd,
        0,
        emptyMappingsForNewParameter,
      );
      parameter.enableCellsForNewColumn = true;
    });

    setParametersData([...parametersData]);

    // delete new parameter after added in to table
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    let leftOrRightVal = pos === "before" ? "left" : "right";
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "template",
        category: "inputs",
        action: `Column Inserted`,
        data: `Column inserted to ${leftOrRightVal} from original column ${column}`,
      }),
    ]);
  };

  const deleteColumn = (indexOfColToBeRemove, column) => {
    parametersData?.map((parameter, parameterIndex) => {
      parameter.mappings.splice(indexOfColToBeRemove, 1);
    });

    setParametersData([...parametersData]);

    // delete new parameter after added in to table
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "template",
        category: "inputs",
        action: `Column Deleted`,
        data: `Column ${column} deleted`,
      }),
    ]);
  };

  const updateDataUsingManuallyContextMenu = (
    rowIndex,
    columnId,
    dragToValues,
  ) => {
    if (
      parametersData[rowIndex].mappings[columnId] &&
      parametersData[rowIndex].mappings[columnId]?.value &&
      (parametersData[rowIndex].mappings[columnId]?.value !== undefined ||
        parametersData[rowIndex].mappings[columnId]?.value !== "")
    ) {
      let selectedCellvalueToFill = parametersData[rowIndex].mappings[columnId];
      let noOfSelectedCol = columnId;

      if (dragToValues?.pos === "right") {
        const totColumnsFromState = parametersData[0]?.mappings?.length;
        // finding remeaninng size col columns by extraction current col number
        const exceptCurrentColRemeaningColslength =
          totColumnsFromState - (noOfSelectedCol + 1); // added +1 because in cnc index starting from 0 and in ff index starting from 1

        for (
          let i = 1;
          i <= Math.min(exceptCurrentColRemeaningColslength, dragToValues?.nos);
          i++
        ) {
          const nextColIdToFill = parseInt(noOfSelectedCol) + i;
          const nextColId = nextColIdToFill;
          parametersData[rowIndex].mappings[nextColId] = {
            ...selectedCellvalueToFill,
            forNoPreProMappingDataEntryByPro: true,
          };
        }
        setParametersData([...parametersData]);
      }

      if (dragToValues?.pos === "left") {
        // finding remeaninng size col columns by extraction current col number
        const exceptCurrentColRemeaningColslength = noOfSelectedCol - 1;

        for (
          let i = 1;
          i <=
          Math.min(exceptCurrentColRemeaningColslength + 1, dragToValues?.nos); // added +1 because in cnc col index start from col1...coln bt on free-form its start from 0...n
          i++
        ) {
          const prevColIdToFill = parseInt(noOfSelectedCol) - i;
          const prevColId = prevColIdToFill;
          parametersData[rowIndex].mappings[prevColId] = {
            ...selectedCellvalueToFill,
            forNoPreProMappingDataEntryByPro: true,
          };
        }
        setParametersData([...parametersData]);
      }

      if (dragToValues?.pos === "above") {
        // in below func tme remained row is same as rowIndex because it shows up to yet remeaning rows
        for (let i = 1; i <= Math.min(rowIndex, dragToValues?.nos); i++) {
          const nextColIdToFill = parseInt(rowIndex) - i;
          parametersData[nextColIdToFill].mappings[columnId] = {
            ...selectedCellvalueToFill,
            forNoPreProMappingDataEntryByPro: true,
          };
        }
        setParametersData([...parametersData]);
      }

      if (dragToValues?.pos === "below") {
        const totRowsFromState = parametersData;

        const exceptCurrentRowRemeaningRowslength =
          totRowsFromState.length - 1 - rowIndex;

        for (
          let i = 1;
          i <= Math.min(exceptCurrentRowRemeaningRowslength, dragToValues?.nos);
          i++
        ) {
          const nextRowIdToFill = parseInt(rowIndex) + i;
          parametersData[nextRowIdToFill].mappings[columnId] = {
            ...selectedCellvalueToFill,
            forNoPreProMappingDataEntryByPro: true,
          };
        }
        setParametersData([...parametersData]);
      }
      if (!anyOperationPerformedOnEntirePage.current) {
        anyOperationPerformedOnEntirePage.current = true;
      }

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          isActivity: true,
          extractionType: "template",
          category: "inputs",
          action: `Data Copied via Context Menu`,
          data: `Row ${rowIndex} of column ${columnId} copied to ${dragToValues?.pos} ${dragToValues?.nos} cells`,
        }),
      ]);
    }
  };

  const onBlurParameterNameChangeInput = (value, parameterIndex) => {
    const parameterNameBeforeChange = parametersData[parameterIndex].parameter;
    parametersData[parameterIndex].parameter = value;
    setParametersData([...parametersData]);
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "template",
        category: "dataEntry",
        action: `Parameter Name Updated`,
        parameter: parameterNameBeforeChange,
        value: value,
        rowColIndex: [parseInt(parameterIndex) + 1],
        dataType: parametersData[parameterIndex]?.dataType,
        rangeMin: parametersData[parameterIndex]?.range?.min,
        rangeMax: parametersData[parameterIndex]?.range?.max,
      }),
    ]);
  };

  const updateLastSelectedPageForProUpdateMapping = (values) => {
    dispatch(setSelectedFileDataForProUpdateMapping(values));
  };

  const onClickProMappingResetButton = () => {
    dispatch(
      resetProDataFromPre(localStorage.projectId, localStorage.projectType),
    );

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "template",
        category: "inputs",
        action: "Processor Mapping Reset ",
      }),
    ]);
  };

  // const isDisableInfoIcon = (
  //   isDataRejectedByProcessor,
  //   cellRejected,
  //   rowRejected,
  //   isDataRejectedByValidator,
  //   valiCellRejected,
  //   valiRowRejected,
  //   cellResolved,
  //   rowResolved,
  //   newColumn,
  //   enableCellsForNewColumn
  // ) => {
  //   let isDisable = false;

  //   if (role === "preProcessor") {
  //     if (isDataRejectedByProcessor) {
  //       isDisable = true;
  //       if (cellRejected || rowRejected) {
  //         isDisable = false;
  //       }
  //       if (newColumn === true && enableCellsForNewColumn === true) {
  //         isDisable = false;
  //       }
  //     }
  //     if (entireBatchRejectedByPro) {
  //       isDisable = false;
  //     }
  //   } else if (role === "processor") {
  //     if (isDataRejectedByValidator) {
  //       isDisable = true;
  //       if (
  //         valiCellRejected ||
  //         valiRowRejected ||
  //         cellResolved ||
  //         rowResolved
  //       ) {
  //         isDisable = false;
  //       }
  //       if (newColumn === true && enableCellsForNewColumn === true) {
  //         isDisable = false;
  //       }
  //     }
  //     if (entireBatchRejectedByVali) {
  //       isDisable = false;
  //     }
  //   }

  //   return isDisable;
  // };

  const handleCloseSuccess = () => {
    setSuccess(false);
    window.location.reload();
  };

  const updateParameterQuestion = (question, parameterIndex, mappingIndex) => {
    if (
      parametersData[parameterIndex].mappings[mappingIndex]
        ?.parameter_question !== question
    ) {
      parametersData[parameterIndex].mappings[mappingIndex] = {
        ...parametersData[parameterIndex].mappings[mappingIndex],
        parameter_question: question,
      };
      setParametersData([...parametersData]);

      const isEmpty = (v) => v == null || v === "";

      if (
        isEmpty(
          parametersData?.[parameterIndex]?.mappings?.[mappingIndex]?.pageNo,
        ) &&
        isEmpty(
          parametersData?.[parameterIndex]?.mappings?.[mappingIndex]?.tagName,
        )
      ) {
        parametersData[parameterIndex].mappings[mappingIndex] = {
          ...parametersData[parameterIndex].mappings[mappingIndex],
          fileNo: selectedFilesDataForProUpdate?.fileNo,
          pageNo: selectedFilesDataForProUpdate?.pageNo,
          tagName: selectedFilesDataForProUpdate?.tagName,
          lockedPreTagName: selectedFilesDataForProUpdate?.tagName,
          lockedPrePageNo: selectedFilesDataForProUpdate?.pageNo,
          lockedPreFileNo: selectedFilesDataForProUpdate?.fileNo,
          forNoPreProMappingDataEntryByPro: true,
          actual_page_number: selectedFilesDataForProUpdate?.pageNo,
        };
      }

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "template",
          category: role === "processor" ? "dataEntry" : "mapping",
          action: "Context Updated",
          parameter: parametersData[parameterIndex]?.parameter,
          rangeMin: parametersData[parameterIndex]?.range?.["min"],
          rangeMax: parametersData[parameterIndex]?.range?.["max"],
          pageNo: parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
          tagName:
            parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
          fileNo: parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
          coordinates:
            parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
          coordinatesValues:
            parametersData[parameterIndex]?.mappings[mappingIndex]
              ?.coordinatesValues,
          dataType: parametersData[parameterIndex]?.dataType,
          value: parametersData[parameterIndex].mappings[mappingIndex]?.value,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            parseInt(mappingIndex) + 1,
          ],
          remark: question,
          mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo,
              )
            ]?.pages[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo,
              )
            ]?.imageUrl,
          // ...(role === "processor"
          //   ? { processorRejected: true }
          //   : { validatorRejected: true }),
        }),
      ]);
    }
  };

  const handleChangeReProcess = (type, parameterIndex, mappingIndex) => {
    const mapping = parametersData[parameterIndex].mappings[mappingIndex];

    if (type === "addToReProcess") {
      mapping.reInitiateProVlm = true;
      mapping.proVlmPageNo = selectedFilesDataForProUpdate?.pageNo;
      mapping.proVlmTagName = selectedFilesDataForProUpdate?.tagName;
      mapping.proVlmFileNo = selectedFilesDataForProUpdate?.fileNo;

      // as from ai not getting below values so updating in fe
      // mapping.pageNo = selectedFilesDataForProUpdate?.pageNo;
      mapping.fileNo = selectedFilesDataForProUpdate?.fileNo;
      mapping.tagName = selectedFilesDataForProUpdate?.tagName;
      mapping.previousValue =
        parametersData[parameterIndex].mappings[mappingIndex]?.value;
      // is_value_updated: true, commenting because storing accurate key from backend by value comparision
      // end of values

      setReProcessVlmCounts((prevCnt) => prevCnt + 1);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "template",
          category: "dataEntry",
          action: "Cell Re-Processed",
          parameter: parametersData[parameterIndex]?.parameter,
          rangeMin: parametersData[parameterIndex]?.range?.["min"],
          rangeMax: parametersData[parameterIndex]?.range?.["max"],
          pageNo: parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
          tagName:
            parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
          fileNo: parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
          coordinates:
            parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
          coordinatesValues:
            parametersData[parameterIndex]?.mappings[mappingIndex]
              ?.coordinatesValues,
          dataType: parametersData[parameterIndex]?.dataType,
          value: parametersData[parameterIndex].mappings[mappingIndex]?.value,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            parseInt(mappingIndex) + 1,
          ],
          mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo,
              )
            ]?.pages[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo,
              )
            ]?.imageUrl,
        }),
      ]);
    } else if (type === "remmoveFromReProcess") {
      delete mapping.reInitiateProVlm;
      delete mapping.proVlmPageNo;
      delete mapping.proVlmTagName;
      delete mapping.proVlmFileNo;
      delete mapping.previousValue;
      // delete mapping.is_value_updated;  commenting because storing accurate key from backend by value comparision

      // as from ai not getting below values so updating in fe
      // mapping.pageNo = mapping?.lockedPrePageNo;
      mapping.fileNo = mapping?.lockedPreFileNo;
      mapping.tagName = mapping?.lockedPreTagName;

      // end of values

      setReProcessVlmCounts((prevCnt) => prevCnt - 1);

      setLogs((prevLogs) => [
        ...prevLogs,
        logObject({
          extractionType: "template",
          category: "dataEntry",
          action: "Cell Re-Processing Undone",
          parameter: parametersData[parameterIndex]?.parameter,
          rangeMin: parametersData[parameterIndex]?.range?.["min"],
          rangeMax: parametersData[parameterIndex]?.range?.["max"],
          pageNo: parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
          tagName:
            parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
          fileNo: parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
          coordinates:
            parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
          coordinatesValues:
            parametersData[parameterIndex]?.mappings[mappingIndex]
              ?.coordinatesValues,
          dataType: parametersData[parameterIndex]?.dataType,
          value: parametersData[parameterIndex].mappings[mappingIndex]?.value,
          rowColIndex: [
            parseInt(parameterIndex) + 1,
            parseInt(mappingIndex) + 1,
          ],
          mbrName: selectedFile?.originalFileName,
          document:
            coordinatesData[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo,
              )
            ]?.pages[
              parseInt(
                parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo,
              )
            ]?.imageUrl,
        }),
      ]);
    }
    setParametersData([...parametersData]);
  };

  const updateMappingsInPro = (parameterIndex, mappingIndex) => {
    const mapping = parametersData?.[parameterIndex]?.mappings?.[mappingIndex];
    if (!mapping) return;

    if (mapping.pageNo !== undefined) {
      mapping.lockedPrePageNo = mapping.pageNo;
    }

    if (mapping.tagName !== undefined) {
      mapping.lockedPreTagName = mapping.tagName;
    }

    if (mapping.fileNo !== undefined) {
      mapping.lockedPreFileNo = mapping.fileNo;
    }

    // update with new values
    mapping.actual_page_number = selectedFilesDataForProUpdate?.pageNo ?? null;
    mapping.tagName = selectedFilesDataForProUpdate?.tagName ?? null;
    mapping.fileNo = selectedFilesDataForProUpdate?.fileNo ?? null;
    mapping.pageNo = selectedFilesDataForProUpdate?.pageNo ?? null;

    mapping.coordinates = [];
    mapping.coordinatesValues = [];

    mapping.mappingsUpdatedByPro = true;

    mapping.processor = localStorage.userName;
    mapping.processedDate = moment(new Date()).format("DD-MMM-YYYY");

    setParametersData([...parametersData]);

    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        extractionType: "template",
        category: "dataEntry",
        action:
          // string === "valueMapping"
          //   ?
          "Mapping updated by Processor",
        // : "Add Parameter Key Mapping",
        parameter: parametersData[parameterIndex]?.parameter,
        templateTagName: parametersData[parameterIndex]?.tagName,
        dataType: parametersData[parameterIndex]?.dataType,
        rangeMin: parametersData[parameterIndex]?.range?.["min"],
        rangeMax: parametersData[parameterIndex]?.range?.["max"],
        coordinates:
          // string === "valueMapping"
          //   ?
          parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates,
        // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
        //     ?.coordinates,
        coordinatesValues:
          // string === "valueMapping"
          //   ?
          parametersData[parameterIndex]?.mappings[mappingIndex]
            ?.coordinatesValues,
        // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
        //     ?.coordinatesValues,

        tagName:
          // string === "valueMapping"
          //   ?
          parametersData[parameterIndex]?.mappings[mappingIndex]?.tagName,
        // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
        //     ?.tagName,

        pageNo:
          // string === "valueMapping"
          //   ?
          parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo,
        // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
        //     ?.pageNo,

        fileNo:
          // string === "valueMapping"
          //   ?
          parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo,
        // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
        //     ?.fileNo,

        rowColIndex: [parseInt(parameterIndex) + 1, parseInt(mappingIndex) + 1],
        mbrName: selectedFile?.originalFileName || "",
        document:
          coordinatesData[selectedFile?.fileNo]?.pages[selectedFile?.pageNo]
            ?.imageUrl,
      }),
    ]);
  };

  const addColumnsAtEnd = (count) => {
    const numericCount = Number(count);

    if (!parametersData || !parametersData[0]?.mappings) return;

    const currentLength = parametersData[0].mappings.length;

    // 1. Update column widths
    const updatedWidths = { ...columnWidths };
    for (let i = 0; i < numericCount; i++) {
      updatedWidths[`header${currentLength + i}`] = 105;
    }
    setColumnWidths(updatedWidths);

    // 2. Prepare new column template
    const createEmptyMapping = () => ({
      tagName: "",
      pageNo: "",
      fileNo: "",
      coordinates: [],
      value: "",
      coordinatesValues: [],
      newColumn: true,
      ...(role === "processor" && {
        forNoPreProMappingDataEntryByPro: true,
      }),
    });

    // 3. Create updated data (IMMUTABLE)
    const updatedParameters = parametersData.map((parameter) => {
      const newMappings = [...parameter.mappings];

      for (let i = 0; i < numericCount; i++) {
        newMappings.push(createEmptyMapping());
      }

      return {
        ...parameter,
        mappings: newMappings,
        enableCellsForNewColumn: true,
      };
    });

    setParametersData(updatedParameters);

    // 4. Mark operation
    if (!anyOperationPerformedOnEntirePage.current) {
      anyOperationPerformedOnEntirePage.current = true;
    }

    // 5. Logs
    setLogs((prevLogs) => [
      ...prevLogs,
      logObject({
        isActivity: true,
        extractionType: "template",
        category: "inputs",
        action: "Columns Added (Bulk)",
        data: `${numericCount} columns added at end`,
      }),
    ]);
  };

  const resetCoordinates = (parameterIndex, mappingIndex) => {
    parametersData[parameterIndex].mappings[mappingIndex].coordinates = [];
    parametersData[parameterIndex].mappings[mappingIndex].coordinatesValues =
      [];
    setParametersData([...parametersData]);
    if (role === "preProcessor") {
      dispatch(heighlightBBoxInPre());
    }
  };

  const showCoordinates = (parameterIndex, mappingIndex) => {
    dispatch(
      heighlightBBoxInPre({
        fileNo: parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
        tagName: parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
        pageNo: parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
        coordinates:
          parametersData[parameterIndex].mappings[mappingIndex]?.coordinates,
      }),
    );
  };

  return (
    <Box>
      {showParameterTable && (
        <Box
        // className="container-1"
        // className={isFullView ? "container-2" : "container-1"}
        // noValidate
        // autoComplete="off"
        >
          {/* {anyOperationPerformedOnEntirePage.current && window.confirm("Are you sure you want to leave?") } */}
          {/* <Prompt
        when={anyOperationPerformedOnEntirePage.current}
        message="Changes that you made may not be saved."
      /> */}
          {/* <Prompt when={anyOperationPerformedOnEntirePage.current} /> */}

          <Box>
            {/* Add Row/Col */}
            <Grid container>
              {/* {!isFullView && role === "preProcessor" && ( */}
              {role === "preProcessor" && (
                <Grid
                  Item
                  md={12}
                  className="addRow-dataMap"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <>
                    <MapInput addMappingRowCallback={addMappingRowCallback} />
                    <NewParameter
                      role={role}
                      handleAddParameter={handleAddParameter}
                    />
                    <Buttons
                      onClick={onClickProMappingResetButton}
                      className="reset-data"
                      text="Reset Processor Mappings"
                      variant="outlined"
                      size="small"
                    />
                    <Buttons
                      onClick={onClickResetButton}
                      className="reset-data"
                      text="Reset Data"
                      variant="outlined"
                      size="small"
                    />{" "}
                  </>
                </Grid>
              )}
              {/* Reset Button For Procesor */}
              {role === "processor" && (
                <Grid Item xs={12} className="addRow-dataMap-reset">
                  <Tabs
                    className="left-aligned-tabs"
                    size="small"
                    value={0}
                    TabIndicatorProps={{
                      style: {
                        marginBottom: "2px", // Adds some space between the indicator and the tab text
                      },
                    }}
                    sx={{
                      minHeight: "35px", // Set minimum height for the Tabs component
                      height: "38px", // Set fixed height for the Tabs component
                      paddingTop: "5px",
                      paddingLeft: "20px",
                    }}
                  >
                    {/* Parameter Table Tab */}
                    <Tab
                      label="Extraction"
                      className="mapping_toggle_tab"
                      sx={{
                        backgroundColor: "#1976d2",
                        color: "#ffff !important",
                        transition: "background-color 0.3s",
                        minHeight: "20px", // Decrease the height of the tab
                        padding: "5px 10px", // Padding to make it look smaller
                        fontSize: "0.875rem", // Smaller font size
                        borderRadius: "6px",
                      }}
                    />
                  </Tabs>
                  <Box>
                    <Tooltip
                      title="This output is AI-generated. Please verify it before proceeding."
                      arrow
                    >
                      <IconButton size="small" sx={{ marginRight: "10px" }}>
                        <WarningAmberOutlinedIcon
                          fontSize="small"
                          color="warning"
                        />
                      </IconButton>
                    </Tooltip>

                    <NewParameter
                      role={role}
                      handleAddParameter={handleAddParameter}
                    />
                  </Box>
                  <MapInput
                    addMappingRowCallback={(colCount) =>
                      addColumnsAtEnd(colCount)
                    }
                  />

                  {/* Temp commented as api is not working  */}
                  {/* <Buttons
                    onClick={onClickResetButtonProApiCall}
                    className="reset-data"
                    text="Reset Data"
                    variant="outlined"
                    size="small"
                  /> */}
                </Grid>
              )}
            </Grid>

            {/* Paremeters Table */}
            {/* <div
              style={{
                overflow: "scroll",
                // , marginRight: "7px"
              }}
            > */}

            {role === "validator" && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  px: 1.5,
                  py: 0.75,
                  minHeight: 38,
                  border: "1px solid #E0E0E0",
                  borderBottom: "none",
                  bgcolor: "#FAFAFA",
                  flexWrap: "wrap",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                    px: 1,
                    py: 0.4,
                    borderRadius: "4px",
                    bgcolor: "#E8F5E9",
                    color: "#2E7D32",
                    fontSize: "12px",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  <Box
                    sx={{
                      width: 6,
                      height: 6,
                      borderRadius: "50%",
                      bgcolor: "#2E7D32",
                    }}
                  />
                  AI-Extracted Fields Changed: {summary?.value_updates ?? 0}
                  {/* /{" "}
                  {summary?.total ?? 0} */}
                </Box>

                <Typography
                  variant="caption"
                  sx={{
                    color: "#757575",
                    fontSize: "11px",
                  }}
                >
                  Only fields with OCR-extracted values are counted
                </Typography>
              </Box>
            )}
            <Grid
              container
              className={
                role === "preProcessor"
                  ? "DataMapTable-wrap"
                  : role === "processor"
                    ? "DataMapTable-wrap processor"
                    : role === "validator"
                      ? "DataMapTable-wrap validationValidator"
                      : "DataMapTable-wrap"
              }
              style={{ width: "100%" }}
            >
              {/*heading block  */}
              <Grid
                item
                {...(hideScreen !== true && { xs: 12 })}
                className="table-row"
              >
                <Item
                  className="DataMap-header table-cell resizable"
                  style={{
                    width: columnWidths.sr,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onMouseDown={handleMouseDown("sr")}
                >
                  <Label text="Sr."></Label>
                </Item>
                <Item
                  className="DataMap-header table-cell resizable"
                  style={{
                    width: columnWidths.parameter,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onMouseDown={handleMouseDown("parameter")}
                >
                  <Label text="Parameters">Parameter</Label>
                </Item>
                <Item
                  className="datatype-wrap table-cell resizable"
                  style={{
                    width: columnWidths.dataType,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onMouseDown={handleMouseDown("dataType")}
                >
                  <Label text="Data Type">Data Type</Label>
                </Item>
                <Item
                  className="rangeSelect-wrap table-cell resizable"
                  style={{
                    width: columnWidths.range,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onMouseDown={handleMouseDown("range")}
                >
                  <Label text="Range" />
                </Item>
                {parametersData && Array.isArray(parametersData[0]?.mappings)
                  ? parametersData[0]?.mappings?.map(
                      (mapping, mappingIndex) => (
                        <Item
                          className={`table-cell resizable ${mapping?.newColumn} ? "new-column" : ""`}
                          style={{
                            width: columnWidths[`header${mappingIndex}`],
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onMouseDown={handleMouseDown(`header${mappingIndex}`)}
                        >
                          <AddMoreColumnTH
                            column={headerAlphabetString(mappingIndex + 1)}
                            addColInBetween={addColInBetween}
                            deleteColumn={deleteColumn}
                            showColHeadersMenu={role !== "validator"}
                            mappingIndex={mappingIndex}
                            role={role}
                          />
                        </Item>
                      ),
                    )
                  : null}
                {/* 1st Common Checkbox in all processor n validator  */}
                {role === "processor" && (
                  <Grid
                    Item
                    className="reject-cell header-reject-cell"
                    id="pro-rej"
                  >
                    <Label text="Reject" padding="16px 4px"></Label>
                  </Grid>
                )}
                {role === "validator" && (
                  <>
                    {" "}
                    <Grid Item className="reject-coloumn header-reject-cell">
                      <Label text="Accept" padding="16px 4px" />
                      <Label
                        text={validatedAndRejectedCounts?.validated}
                        padding="0px 0px"
                      ></Label>
                    </Grid>
                    <Grid
                      className="reject-coloumn header-reject-cell"
                      Item
                      id="vali-rej"
                    >
                      <Label text="Reject" padding="16px 4px"></Label>
                      <Label
                        text={validatedAndRejectedCounts?.rejected}
                        padding="0px 0px"
                      ></Label>
                    </Grid>
                  </>
                )}
                {/* 1st Checkbox in Pre processor after rejected by processor */}
                {role === "preProcessor" && isDataRejectedByProcessor && (
                  <Grid
                    Item
                    className="reject-cell header-reject-cell"
                    id="Pro-rej"
                  >
                    <Label text="Rejected By Processor" padding="0px"></Label>
                  </Grid>
                )}
                {/* 2nd Checkbox in processor after rejected by vali */}
                {role === "processor" && isDataRejectedByValidator && (
                  <Grid
                    Item
                    className="reject-cell header-reject-cell"
                    id="vali-rej"
                  >
                    <Label text="Rejected By Validator" padding="0px"></Label>
                  </Grid>
                )}{" "}
                {/* 2nd Checkbox in Validator after rejected by vali */}
                {role === "validator" &&
                  isDataRejectedByInvestigatorValidator && (
                    <Grid
                      className="reject-cell header-reject-cell"
                      Item
                      id="vali-rej"
                    >
                      <Label
                        text="Rejected by approver"
                        padding="16px 4px"
                      ></Label>
                    </Grid>
                  )}
                {(role === "processor" || role === "validator") &&
                  showReviewRemarkColumnHeader && (
                    // parameterData?.processorRowRejection?.isResolved &&
                    <Grid
                      Item
                      className="reject-cell header-reject-cell"
                      id="vali-rej-remark"
                    >
                      <Label
                        text="Previous Rejection Remark"
                        padding="0px"
                      ></Label>
                    </Grid>
                  )}
                {role === "preProcessor" &&
                  isDataRejectedByInvestigatorMappingValidator && (
                    <Grid
                      className="reject-cell header-reject-cell"
                      Item
                      id="vali-rej"
                    >
                      <Label
                        text="Rejected by approver"
                        padding="16px 4px"
                      ></Label>
                    </Grid>
                  )}
              </Grid>
              {/*End heading block  */}
              {Array.isArray(parametersData)
                ? parametersData?.map((parameterData, parameterIndex) => (
                    <>
                      <Grid
                        item
                        {...(hideScreen !== true && { xs: 12 })}
                        className="DataMapTable"
                        key={parameterIndex}
                      >
                        {" "}
                        <Item style={{ width: columnWidths.sr }}>
                          {parameterIndex + 1}
                        </Item>
                        <Item style={{ width: columnWidths.parameter }}>
                          <ParameterName
                            name={parameterData?.parameter}
                            onBlurParameterNameChangeInput={(value) =>
                              onBlurParameterNameChangeInput(
                                value,
                                parameterIndex,
                              )
                            }
                            isNameEditable={
                              role === "preProcessor" || role === "processor"
                                ? true
                                : false
                            }
                          />
                        </Item>
                        <Item
                          className="datatype-wrap-selector "
                          style={{ width: columnWidths.dataType }}
                        >
                          <DataTypeSelector
                            parameterData={parameterData}
                            onHandleChangeDatatype={onHandleChangeDatatype}
                            parameterIndex={parameterIndex}
                            isDataRejectedByProcessor={
                              isDataRejectedByProcessor
                            }
                            role={role}
                            entireBatchRejectedByPro={entireBatchRejectedByPro}
                            isDataRejectedByInvestigatorMappingValidator={
                              isDataRejectedByInvestigatorMappingValidator
                            }
                            entireBatchRejectedByInvestigatorMappingValidator={
                              entireBatchRejectedByInvestigatorMappingValidator
                            }
                          />
                        </Item>
                        <Item
                          className="range-selector "
                          style={{ width: columnWidths.range }}
                        >
                          <RangeSelector
                            handleRange={handleRange}
                            parameterIndex={parameterIndex}
                            dataType={parameterData?.dataType}
                            selectedRange={parameterData?.range}
                            role={role}
                            entireBatchRejectedByPro={entireBatchRejectedByPro}
                            isDataRejectedByProcessor={
                              isDataRejectedByProcessor
                            }
                            parameterData={parameterData}
                            entireBatchRejectedByInvestigatorMappingValidator={
                              entireBatchRejectedByInvestigatorMappingValidator
                            }
                            isDataRejectedByInvestigatorMappingValidator={
                              isDataRejectedByInvestigatorMappingValidator
                            }
                          />
                        </Item>
                        {Array.isArray(parameterData?.mappings)
                          ? parameterData.mappings.map(
                              (mapping, mappingIndex) => (
                                <Item
                                  className="datatype-wrap"
                                  sx={
                                    role !== "preProcessor" && {
                                      ...(Validation(
                                        parametersData[parameterIndex]
                                          ?.dataType,
                                        parametersData[parameterIndex]?.range,
                                        mapping?.value,
                                      )?.error && {
                                        border: "2px solid!important",
                                        borderRadius: "5px!important",
                                        borderColor: "#ff9800!important",
                                      }),
                                    }
                                  }
                                  style={{
                                    width:
                                      columnWidths[`header${mappingIndex}`],
                                  }}
                                >
                                  <EditableCell
                                    mapping={mapping}
                                    mappingIndex={mappingIndex}
                                    parameterIndex={parameterIndex}
                                    parametersData={parametersData}
                                    setParametersData={setParametersData}
                                    // rowRejectionData={rowRejectionData}
                                    role={role}
                                    onClickMapping={onClickMapping}
                                    onClickCellToRedirect={
                                      onClickCellToRedirect
                                    }
                                    anyOperationPerformedOnEntirePage={
                                      anyOperationPerformedOnEntirePage
                                    }
                                    reProcess={reProcess}
                                    isDataRejectedByProcessor={
                                      isDataRejectedByProcessor
                                    }
                                    isDataRejectedByValidator={
                                      isDataRejectedByValidator
                                    }
                                    isDataRejectedByInvestigatorValidator={
                                      isDataRejectedByInvestigatorValidator
                                    }
                                    entireBatchRejectedByInvestigatorValidator={
                                      entireBatchRejectedByInvestigatorValidator
                                    }
                                    reValidate={reValidate}
                                    clearMappings={(type) =>
                                      clearMappings(
                                        parameterIndex,
                                        mappingIndex,
                                        type,
                                      )
                                    } // common function used for clear mapings from cell menu and using backspace and delete buttom
                                    entireBatchRejectedByPro={
                                      entireBatchRejectedByPro
                                    }
                                    entireBatchRejectedByVali={
                                      entireBatchRejectedByVali
                                    }
                                    reProcessEntireBatch={reProcessEntireBatch}
                                    showContextMenu={showContextMenu}
                                    updateDataUsingManuallyContextMenu={
                                      updateDataUsingManuallyContextMenu
                                    }
                                    selectedFilesDataForProUpdate={
                                      selectedFilesDataForProUpdate
                                    }
                                    setLogs={setLogs}
                                    logs={logs}
                                    selectedFile={selectedFile}
                                    coordinatesData={coordinatesData}
                                    updateLastSelectedPageForProUpdateMapping={
                                      updateLastSelectedPageForProUpdateMapping
                                    }
                                    isDataRejectedByInvestigatorMappingValidator={
                                      isDataRejectedByInvestigatorMappingValidator
                                    }
                                    entireBatchRejectedByInvestigatorMappingValidator={
                                      entireBatchRejectedByInvestigatorMappingValidator
                                    }
                                    // parameterKey={parameterKey}
                                    // onClickParameterKeyMapping={onClickParameterKeyMapping}
                                  />

                                  {((role === "preProcessor" &&
                                    (mapping?.processorCellRejection
                                      ?.isRejected === true ||
                                      mapping
                                        ?.investigatorMappingValidatiorCellRejection
                                        ?.isRejected === true ||
                                      (mapping?.pageNo >= 0 &&
                                        mapping?.tagName &&
                                        (mapping?.parameter_question ||
                                          mapping?.parameter_question ===
                                            "")))) ||
                                    role === "processor" ||
                                    role === "validator") && (
                                    <CellMenu
                                      parameter_question={
                                        mapping?.parameter_question
                                      }
                                      updateParameterQuestion={(question) =>
                                        updateParameterQuestion(
                                          question,
                                          parameterIndex,
                                          mappingIndex,
                                        )
                                      }
                                      isRejectedByProcessor={
                                        mapping?.processorCellRejection
                                          ?.isRejected
                                      }
                                      processorRejectionRemark={
                                        mapping?.processorCellRejection?.remark
                                      }
                                      isRejectedByValidator={
                                        mapping?.validatorCellRejection
                                          ?.isRejected
                                      }
                                      validatorRejectionRemark={
                                        mapping?.validatorCellRejection?.remark
                                      }
                                      rejectCell={(rejectionRemark) =>
                                        rejectCell(
                                          rejectionRemark,
                                          parameterIndex,
                                          mappingIndex,
                                        )
                                      }
                                      deleteRejection={() =>
                                        deleteRejection(
                                          parameterIndex,
                                          mappingIndex,
                                        )
                                      }
                                      role={role}
                                      markAsResolveByProcessor={() =>
                                        markAsResolveByProcessor(
                                          parameterIndex,
                                          mappingIndex,
                                          isDataRejectedByInvestigatorMappingValidator,
                                        )
                                      }
                                      isRwoValidated={
                                        parameterData?.rowValidation
                                          ?.isValidated
                                      }
                                      heading={
                                        role === "preProcessor"
                                          ? action.REJECTION_REMARK
                                          : action.REJECTION_PROMPT
                                      }
                                      isResolvedProcessorCellRejection={
                                        mapping?.processorCellRejection
                                          ?.isResolved
                                      }
                                      isResolvedValidatorCellRejection={
                                        mapping?.validatorCellRejection
                                          ?.isResolved
                                      }
                                      reInitiateProVlm={
                                        mapping?.reInitiateProVlm
                                      }
                                      handleChangeReProcess={(type) =>
                                        handleChangeReProcess(
                                          type,
                                          parameterIndex,
                                          mappingIndex,
                                        )
                                      }
                                      // processorsRejectionCounts={
                                      //   processorsRejectionCounts
                                      // }
                                      reProcessVlmCounts={reProcessVlmCounts}
                                      ref={cellMenuRef} // new for qc context to auto open on mapping
                                      isRejectedByInvestigatorValidator={
                                        mapping
                                          ?.investigatorValidatiorCellRejection
                                          ?.isRejected
                                      }
                                      investigatorValidatorRejectionRemark={
                                        mapping
                                          ?.investigatorValidatiorCellRejection
                                          ?.remark
                                      }
                                      isDataRejectedByInvestigatorValidator={
                                        isDataRejectedByInvestigatorValidator
                                      }
                                      isRejectedByInvestigatorMappingValidator={
                                        mapping
                                          ?.investigatorMappingValidatiorCellRejection
                                          ?.isRejected
                                      }
                                      investigatorMappingValidatorRejectionRemark={
                                        mapping
                                          ?.investigatorMappingValidatiorCellRejection
                                          ?.remark
                                      }
                                      isDataRejectedByInvestigatorMappingValidator={
                                        isDataRejectedByInvestigatorMappingValidator
                                      }
                                      updateMappingsInPro={() =>
                                        updateMappingsInPro(
                                          parameterIndex,
                                          mappingIndex,
                                        )
                                      }
                                      resetCoordinates={() =>
                                        resetCoordinates(
                                          parameterIndex,
                                          mappingIndex,
                                        )
                                      }
                                      showCoordinates={() =>
                                        showCoordinates(
                                          parameterIndex,
                                          mappingIndex,
                                        )
                                      }
                                      parameterData={parameterData}
                                      entireBatchRejectedByPro={
                                        entireBatchRejectedByPro
                                      }
                                      entireBatchRejectedByVali={
                                        entireBatchRejectedByVali
                                      }
                                      mapping={mapping}
                                      isDataRejectedByValidator={
                                        isDataRejectedByValidator
                                      }
                                      entireBatchRejectedByInvestigatorValidator={
                                        entireBatchRejectedByInvestigatorValidator
                                      }
                                    />
                                  )}

                                  <CellValueHistory
                                    mapping={mapping}
                                    currentValue={mapping?.value}
                                    role={role}
                                  />
                                </Item>
                              ),
                            )
                          : null}
                        {role === "preProcessor" &&
                          isDataRejectedByInvestigatorMappingValidator && (
                            <Grid Item className="reject-cell">
                              <RowRejectAndReviewNew
                                isFirstCheckbox={true}
                                handleRowRejection={handleRowRejection}
                                deleteRowRejection={deleteRowRejection}
                                role={role}
                                isReadOnly={true}
                                isDataRejectedByInvestigatorMappingValidator={
                                  isDataRejectedByInvestigatorMappingValidator
                                }
                                markAsResolveRejection={(parameterIndex) =>
                                  markAsResolveRejection(
                                    parameterIndex,
                                    isDataRejectedByInvestigatorMappingValidator,
                                  )
                                }
                                parameterData={parameterData}
                                parameterIndex={parameterIndex}
                                heading={"Row rejection remark."}
                              />
                            </Grid>
                          )}
                        {/* 1st Common Checkbox in  processor n validator  */}
                        {role === "processor" && (
                          <Grid Item className="reject-cell">
                            <RowRejectAndReviewNew
                              isFirstCheckbox={true}
                              handleRowRejection={handleRowRejection}
                              parameterData={parameterData}
                              deleteRowRejection={deleteRowRejection}
                              role={role}
                              markAsResolveRejection={markAsResolveRejection}
                              parameterIndex={parameterIndex}
                              heading={"Do you want to reject the row?"}
                            />
                          </Grid>
                        )}
                        {/* 1st Checkbox in Pre processor after rejected by processor */}
                        {role === "preProcessor" &&
                          isDataRejectedByProcessor && (
                            <Grid Item className="reject-cell">
                              <RowRejectAndReviewNew
                                parameterData={parameterData}
                                role={role}
                                isReadOnly={true}
                                isDataRejectedByProcessor
                                markAsResolveRejection={markAsResolveRejection}
                                parameterIndex={parameterIndex}
                                heading={"Row Rejection Remark."}
                              />
                            </Grid>
                          )}
                        {/* 2nd Checkbox for validator rejections in processor after rejected by vali */}
                        {role === "processor" && isDataRejectedByValidator && (
                          <Grid Item className="reject-cell">
                            <RowRejectAndReviewNew
                              handleRowRejection={handleRowRejection}
                              deleteRowRejection={deleteRowRejection}
                              role={role}
                              isReadOnly={true}
                              isDataRejectedByValidator
                              markAsResolveRejection={markAsResolveRejection}
                              parameterData={parameterData}
                              parameterIndex={parameterIndex}
                              heading={"Row rejection remark."}
                            />
                          </Grid>
                        )}
                        {role === "processor" &&
                          parameterData?.processorRowRejection?.isResolved && (
                            <Grid Item className="reject-cell">
                              <RowRejectAndReviewNew
                                parameterData={parameterData}
                                role={role}
                                parameterIndex={parameterIndex}
                                heading={"View Remark"}
                                disableFooterBtns={true}
                                icon="view"
                              />
                            </Grid>
                          )}
                        {/* Validation Button */}
                        {role === "validator" && (
                          <>
                            <Grid Item className="reject-cell">
                              <ValidationButton
                                onClickValidate={onClickValidate}
                                parameterData={parameterData}
                                parameterIndex={parameterIndex}
                              />
                            </Grid>
                            <Grid Item className="reject-cell">
                              <RowRejectAndReviewNew
                                handleRowRejection={handleRowRejection}
                                parameterData={parameterData}
                                deleteRowRejection={deleteRowRejection}
                                role={role}
                                markAsResolveRejection={markAsResolveRejection}
                                parameterIndex={parameterIndex}
                                heading={"Do you want to reject the row?"}
                              />
                            </Grid>

                            {/* 2nd Checkbox for validator rejections in vali after rejected by reviewer */}
                            {role === "validator" &&
                              isDataRejectedByInvestigatorValidator && (
                                <Grid Item className="reject-cell">
                                  <RowRejectAndReviewNew
                                    handleRowRejection={handleRowRejection}
                                    deleteRowRejection={deleteRowRejection}
                                    role={role}
                                    isReadOnly={true}
                                    isDataRejectedByInvestigatorValidator
                                    markAsResolveRejection={
                                      markAsResolveRejection
                                    }
                                    parameterData={parameterData}
                                    parameterIndex={parameterIndex}
                                    heading={"Row rejection remark."}
                                  />
                                </Grid>
                              )}

                            {role === "validator" &&
                              parameterData?.validatorRowRejection
                                ?.isResolved && (
                                <Grid Item className="reject-cell">
                                  <RowRejectAndReviewNew
                                    parameterData={parameterData}
                                    role={role}
                                    parameterIndex={parameterIndex}
                                    heading={"View Remark"}
                                    disableFooterBtns={true}
                                    icon="view"
                                  />
                                </Grid>
                              )}
                          </>
                        )}
                      </Grid>
                    </>
                  ))
                : null}
            </Grid>
            {/* </div> */}
            {isAlert?.open && (
              <Snackbar
                open={true}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                key={"topcenter"}
              >
                <Alert
                  onClose={handleClose}
                  className="error-alert"
                  severity="error"
                >
                  <AlertTitle color="white">{isAlert?.title}</AlertTitle>
                  {isAlert?.message}
                </Alert>
              </Snackbar>
            )}
          </Box>
          {openAuth && (
            <Authentication
              openAuth={openAuth}
              handleClose={handleCloseAuth}
              handleUserPermission={handleUserPermission}
            />
          )}
          {openSignPad && (
            <ModalSign
              openSignPad={openSignPad}
              handleEsignDialogBoxClose={handleCloseSignPad}
            ></ModalSign>
          )}
          {success && (
            <CustomizedSnackbars
              severity="success"
              state={success}
              text={message}
              handleClose={() => handleCloseSuccess()}
            />
          )}

          {err && (
            <CustomizedSnackbars
              severity="error"
              state={err}
              text={message}
              handleClose={() => setErr(false)}
            />
          )}
        </Box>
      )}
    </Box>
  );
});

MapDataTable.defaultProps = {
  role: "preProcessor",
};

export default MapDataTable;
